import type { LocaleMessageBundle } from '../../types'

export const payrollMessages: LocaleMessageBundle = {
  vi: {
    'payroll.table_create_failed_notice': 'Thêm bảng lương không thành công.',
    'payroll.queued': 'Đang chờ xử lý',
    'payroll.processing': 'Đang tạo phiếu',
    'payroll.completed': 'Hoàn tất',
    'payroll.failed': 'Xử lý lỗi; có thể kiểm tra và tạo lại các phiếu còn thiếu',
    'payroll.reconcile': 'Đối soát lại',
    'payroll.needs_review': 'Cần đối soát lại',
    'payroll.adjustment_pending': 'Đang chờ chỉnh công',
    'payroll.adjustment_rejected': 'Yêu cầu chỉnh công bị từ chối',
    'payroll.ignore_attendance': 'Bỏ qua bản ghi',
    'payroll.ignore': 'Bỏ qua công ngoài ca',
    'payroll.approve_unscheduled': 'Duyệt công ngoài ca',
    'payroll.assignment': 'Ca được gắn',
    'payroll.check_in': 'Giờ vào',
    'payroll.check_out': 'Giờ ra',
    'payroll.reconcile_hint':
      'Chọn ca phù hợp cho bản ghi chưa có ca. Dữ liệu chấm công gốc được giữ lại.',
    'payroll.leave': 'Nghỉ phép',
    'payroll.overtime': 'Phiếu tăng ca',
    'payroll.allowances': 'Phụ cấp',
    'payroll.allowance_types': 'Danh mục phụ cấp',
    'payroll.allowance_type_create_title': 'Thêm loại phụ cấp',
    'payroll.allowance_type_edit_title': 'Cập nhật loại phụ cấp',
    'payroll.allowance_type_update_success': 'Cập nhật loại phụ cấp thành công.',
    'payroll.advances': 'Ứng lương',
    'payroll.insurance': 'Bảo hiểm',
    'payroll.insurance_settings_staff_tab': 'Mức đóng theo nhân viên',
    'payroll.insurance_settings_records_tab': 'Bản ghi bảo hiểm theo kỳ',
    'payroll.insurance_settings_edit_title': 'Thiết lập bảo hiểm nhân viên',
    'payroll.insurance_settings_update_success':
      'Cập nhật thiết lập bảo hiểm nhân viên thành công.',
    'payroll.insurance_deactivate_success': 'Ngừng áp dụng bảo hiểm thành công.',
    'payroll.insurance_deactivate_failure': 'Ngừng áp dụng bảo hiểm không thành công.',
    'payroll.insurance_settings_bulk_edit': 'Chỉnh sửa',
    'payroll.insurance_settings_bulk_title': 'Chỉnh sửa bảo hiểm hàng loạt',
    'payroll.insurance_settings_selected_count': 'Đã chọn {count} nhân viên',
    'payroll.insurance_settings_use_monthly_salary': 'Sử dụng mức lương tháng để đóng BHXH',
    'payroll.insurance_settings_monthly_salary_unavailable':
      '{count} nhân viên chưa có lương tháng. Hãy thiết lập lương tháng trước khi dùng tùy chọn này.',
    'payroll.insurance_settings_health': 'BHYT',
    'payroll.insurance_settings_unemployment': 'BHTN',
    'payroll.insurance_settings_records_hint':
      'Bản ghi theo kỳ dùng cho khoản bảo hiểm riêng. Nếu nhân viên đã có mức đóng ở tab bên cạnh, khoản khấu trừ trùng sẽ chặn tính phiếu lương.',
    'payroll.social_insurance': 'BHXH nhân viên (8%)',
    'payroll.social_insurance_elsewhere': 'BHXH đã khấu trừ ở phiếu khác cùng tháng',
    'payroll.health_insurance': 'BHYT nhân viên (1,5%)',
    'payroll.health_insurance_elsewhere': 'BHYT đã khấu trừ ở phiếu khác cùng tháng',
    'payroll.unemployment_insurance': 'BHTN nhân viên (1%)',
    'payroll.unemployment_insurance_elsewhere': 'BHTN đã khấu trừ ở phiếu khác cùng tháng',
    'payroll.title': 'Bảng lương',
    'payroll.staff': 'Nhân viên',
    'payroll.search': 'Tìm mã hoặc tên nhân viên',
    'payroll.mine': 'Của tôi',
    'payroll.all': 'Tất cả',
    'payroll.pending': 'Chờ duyệt',
    'payroll.approved': 'Đã duyệt',
    'payroll.approved_paid': 'Đã duyệt / Đã chi',
    'payroll.rejected': 'Từ chối',
    'payroll.rejected_cancelled': 'Từ chối / Đã hủy',
    'payroll.cancelled': 'Đã hủy',
    'payroll.active': 'Đang áp dụng',
    'payroll.inactive': 'Ngừng áp dụng',
    'payroll.status_active': 'Hoạt động',
    'payroll.status_locked': 'Tạm ngưng',
    'payroll.paid': 'Đã thanh toán',
    'payroll.reversed': 'Đã đảo giao dịch',
    'payroll.partially_paid': 'Đã chi một phần',
    'payroll.allocated': 'Đã khấu trừ hết',
    'payroll.status': 'Trạng thái',
    'payroll.starts_on': 'Từ ngày',
    'payroll.ends_on': 'Đến ngày',
    'payroll.reason': 'Lý do',
    'payroll.actions': 'Thao tác',
    'payroll.cancelled_reason_detail': 'Lý do hủy: {reason}',
    'payroll.rejected_reason_detail': 'Lý do từ chối: {reason}',
    'payroll.amount': 'Số tiền',
    'payroll.amount_override': 'Mức phụ cấp riêng',
    'payroll.allowance_type_id': 'Loại phụ cấp',
    'payroll.note': 'Ghi chú',
    'payroll.description': 'Mô tả',
    'payroll.calculation_basis': 'Cách tính phụ cấp',
    'payroll.default_amount': 'Mức mặc định',
    'payroll.require_check_in': 'Bắt buộc có giờ vào',
    'payroll.require_check_out': 'Bắt buộc có giờ ra',
    'payroll.minimum_worked_minutes': 'Số phút làm tối thiểu',
    'payroll.count_paid_leave': 'Tính cả ngày nghỉ hưởng lương',
    'payroll.effective_from': 'Hiệu lực từ',
    'payroll.effective_to': 'Hiệu lực đến',
    'payroll.name': 'Tên khoản',
    'payroll.frequency': 'Chu kỳ',
    'payroll.daily': 'Theo ngày',
    'payroll.monthly': 'Theo tháng',
    'payroll.eligibility': 'Điều kiện hưởng',
    'payroll.worked_day': 'Ngày thực làm',
    'payroll.paid_day': 'Ngày thực làm và nghỉ hưởng lương',
    'payroll.attendance_day': 'Ngày có chấm công',
    'payroll.taxable': 'Chịu thuế',
    'payroll.prorate_on_join': 'Tính tỷ lệ khi vào làm giữa kỳ',
    'payroll.prorate_on_leave': 'Tính tỷ lệ khi nghỉ việc giữa kỳ',
    'payroll.yes': 'Có',
    'payroll.no': 'Không',
    'payroll.half_day': 'Thời gian nghỉ',
    'payroll.leave_hours': 'Số giờ nghỉ',
    'payroll.leave_hour_option': '{hours} giờ ({ratio} ngày)',
    'payroll.full': 'Cả ngày',
    'payroll.morning': 'Buổi sáng',
    'payroll.afternoon': 'Buổi chiều',
    'payroll.leave_type': 'Loại nghỉ',
    'payroll.leave_types': 'Loại nghỉ và hạn mức',
    'payroll.leave_types_subtitle': 'Thiết lập loại nghỉ phép và hạn mức sử dụng',
    'payroll.leave_type_list': 'Danh sách loại nghỉ',
    'payroll.add_leave_type': 'Thêm loại nghỉ',
    'payroll.leave_type_create_title': 'Thêm loại nghỉ mới',
    'payroll.leave_type_edit_title': 'Cập nhật loại nghỉ',
    'payroll.system_default': 'Mặc định hệ thống',
    'payroll.convert_to_unpaid': 'Chuyển sang nghỉ không lương khi hết phép',
    'payroll.convert_to_unpaid_hint':
      'Nếu hạn mức không đủ, toàn bộ đơn sẽ được duyệt dưới loại Nghỉ không lương và không trừ số phép còn lại.',
    'payroll.quota_form_title': 'Cấp hạn mức nghỉ phép',
    'payroll.quota_form_edit_title': 'Cập nhật cấp phép đã lưu',
    'payroll.quota_grant_list': 'Danh sách cấp phép đã lưu',
    'payroll.granted_at': 'Ngày cấp',
    'payroll.check_balance': 'Kiểm tra số dư',
    'payroll.edit': 'Sửa',
    'payroll.delete_leave_type': 'Xóa loại nghỉ',
    'payroll.delete_leave_type_confirm': 'Xóa loại nghỉ “{name}”? Thao tác này không thể hoàn tác.',
    'payroll.delete_allowance_type': 'Xóa loại phụ cấp',
    'payroll.delete_allowance_type_confirm':
      'Xóa loại phụ cấp “{name}”? Thao tác này không thể hoàn tác.',
    'payroll.cancel_edit': 'Hủy sửa',
    'payroll.code': 'Mã',
    'payroll.pay_ratio': 'Tỷ lệ hưởng lương (%)',
    'payroll.deduct_quota': 'Trừ hạn mức phép',
    'payroll.allow_half_day': 'Cho phép nghỉ theo giờ / nửa ngày',
    'payroll.half_days': 'Số nửa ngày phép',
    'payroll.leave_days': 'Số ngày phép',
    'payroll.days_remaining': 'ngày còn lại',
    'payroll.unlimited': 'Không giới hạn',
    'payroll.leave_quota_loading': 'Đang tải số phép còn lại, vui lòng chờ.',
    'payroll.half_days_to_grant': 'Số nửa ngày cấp thêm',
    'payroll.days_to_grant': 'Số ngày cấp phép',
    'payroll.select_staff': 'Chọn nhân viên',
    'payroll.selected_staff': 'Nhân viên đã chọn',
    'payroll.no_staff_selected': 'Chưa có nhân viên nào được chọn',
    'payroll.confirm_selection': 'Xác nhận lựa chọn',
    'payroll.employee_code': 'Mã nhân viên',
    'payroll.employee_name': 'Tên nhân viên',
    'payroll.lock_blocked_days': 'Ngày cần xử lý (nhấn để mở xác nhận công)',
    'payroll.open_attendance_history': 'Lịch sử điểm danh',
    'payroll.lock_ready': 'Tất cả nhân viên đã đủ điều kiện. Bạn có thể lưu để khóa công.',
    'payroll.department': 'Phòng ban',
    'payroll.staff_department': 'Bộ phận',
    'payroll.work_shift': 'Ca làm việc hôm nay',
    'payroll.source_shift': 'Ca làm việc trước tăng ca',
    'payroll.no_overtime_shift_options':
      'Không có loại ca chung phù hợp. Hãy chọn nhân viên cùng ca hoặc tạo phiếu riêng.',
    'payroll.remove_staff': 'Bỏ nhân viên',
    'payroll.remaining_leave_days': 'Phép còn lại (ngày)',
    'payroll.quota': 'Cấp phép',
    'payroll.balance': 'Số nửa ngày phép còn lại',
    'payroll.starts_at': 'Bắt đầu tăng ca',
    'payroll.ends_at': 'Kết thúc tăng ca',
    'payroll.approved_starts_at': 'Thời gian tăng ca được duyệt từ',
    'payroll.approved_ends_at': 'Thời gian tăng ca được duyệt đến',
    'payroll.override_reason': 'Lý do duyệt vượt thời gian đề nghị',
    'payroll.multiplier_percent': 'Hệ số tăng ca (%)',
    'payroll.deduction_month': 'Kỳ khấu trừ (YYYY-MM)',
    'payroll.no_matching_assignment': 'Chưa có ca chưa sử dụng trong ngày này',
    'payroll.advance_policy': 'Điều kiện ứng lương',
    'payroll.advance_policy_update_success': 'Cập nhật điều kiện ứng lương thành công.',
    'payroll.salary_advance_min_workdays': 'Số công tối thiểu trong tháng',
    'payroll.advance_policy_hint': 'Đặt bằng 0 để không giới hạn theo số công.',
    'payroll.advance_eligibility_summary':
      'Công hiện có: {current} · Yêu cầu: {required} · Còn thiếu: {missing}',
    'payroll.number': 'Mã số BHXH',
    'payroll.insurance_number': 'Mã số BHXH',
    'payroll.base': 'Mức lương đóng bảo hiểm',
    'payroll.insurance_base': 'Mức lương đóng bảo hiểm',
    'payroll.employee_basis_points': 'Tỷ lệ nhân viên (%)',
    'payroll.employer_basis_points': 'Tỷ lệ doanh nghiệp (%)',
    'payroll.employee_amount': 'Mức nhân viên đóng cố định',
    'payroll.employer_amount': 'Mức doanh nghiệp đóng cố định',
    'payroll.approve': 'Duyệt',
    'payroll.reject': 'Từ chối',
    'payroll.cancel': 'Hủy phiếu',
    'payroll.input_action_success': '{action} {record} thành công.',
    'payroll.input_action_failure': '{action} {record} không thành công.',
    'payroll.input_action.approve': 'Duyệt',
    'payroll.input_action.reject': 'Từ chối',
    'payroll.input_action.cancel': 'Hủy',
    'payroll.input_action.mark_paid': 'Ghi nhận đã chi cho',
    'payroll.input_action.reverse_payment': 'Hoàn tác lần chi gần nhất của',
    'payroll.input_action.deactivate': 'Ngừng áp dụng',
    'payroll.input_action.reactivate': 'Áp dụng lại',
    'payroll.input_action.reconcile': 'Đối soát lại',
    'payroll.input_action.record.leave': 'phiếu nghỉ phép',
    'payroll.input_action.record.overtime': 'phiếu tăng ca',
    'payroll.input_action.record.allowance_request': 'phiếu phụ cấp',
    'payroll.input_action.record.allowance': 'phụ cấp',
    'payroll.input_action.record.advance': 'phiếu ứng lương',
    'payroll.delete_overtime': 'Xóa phiếu tăng ca',
    'payroll.overtime_delete_confirm': 'Bạn có chắc muốn xóa phiếu tăng ca này không?',
    'payroll.overtime_delete_success': 'Đã xóa phiếu tăng ca.',
    'payroll.overtime_delete_failure': 'Xóa phiếu tăng ca không thành công.',
    'payroll.cancel_overtime': 'Hủy',
    'payroll.mark-paid': 'Ghi nhận đã chi',
    'payroll.reverse-payment': 'Hoàn tác lần chi gần nhất',
    'payroll.disbursed': 'Đã chi',
    'payroll.advance_payment_limit':
      'Có thể chi tối đa {amount} cho lần này. Tối thiểu là {minimum}.',
    'payroll.allocated': 'Đã khấu trừ',
    'payroll.remaining': 'Còn phải thu',
    'payroll.deactivate': 'Ngừng áp dụng',
    'payroll.reactivate': 'Áp dụng lại',
    'payroll.reactivate_effective_on': 'Áp dụng lại từ ngày',
    'payroll.method': 'Phương thức thanh toán',
    'payroll.reference': 'Mã tham chiếu',
    'payroll.confirm': 'Xác nhận',
    'payroll.month': 'Kỳ lương (YYYY-MM)',
    'payroll.table': 'Bảng lương',
    'payroll.table_details': 'Thông tin bảng lương',
    'payroll.created_by': 'Người tạo',
    'payroll.table_payslips': 'Phiếu lương nhân viên',
    'payroll.table_payment_history': 'Lịch sử thanh toán',
    'payroll.audit.history': 'Lịch sử thao tác',
    'payroll.audit.description': 'Theo dõi thời điểm, người thực hiện và nội dung thay đổi của phiếu lương.',
    'payroll.audit.period_description': 'Theo dõi thời điểm, người thực hiện và các thao tác trên bảng lương và phiếu lương.',
    'payroll.audit.empty': 'Chưa có thao tác nào.',
    'payroll.audit.load_more': 'Xem thêm',
    'payroll.audit.unknown_actor': 'Không rõ người thao tác',
    'payroll.audit.staff': 'Nhân viên',
    'payroll.audit.adjustment': 'Khoản điều chỉnh',
    'payroll.audit.adjustment_after': 'Sau khi cập nhật',
    'payroll.audit.payment': 'Số tiền thanh toán',
    'payroll.audit.reference': 'Mã tham chiếu',
    'payroll.audit.reason': 'Lý do',
    'payroll.audit.fields.gross': 'Tổng thu nhập',
    'payroll.audit.fields.deductions': 'Tổng khấu trừ',
    'payroll.audit.fields.net': 'Thực nhận',
    'payroll.audit.fields.manual_work_days': 'Số ngày tính công',
    'payroll.audit.fields.manual_work_minutes': 'Giờ công điều chỉnh (phút)',
    'payroll.audit.workflow.sent': 'Gửi phiếu lương',
    'payroll.audit.workflow.employee_approved': 'Nhân viên xác nhận phiếu lương',
    'payroll.audit.workflow.changes_requested': 'Nhân viên đề nghị chỉnh sửa',
    'payroll.audit.workflow.manager_final_approved': 'Quản lý chốt phiếu lương',
    'payroll.audit.workflow.returned_for_changes': 'Trả phiếu lương để chỉnh sửa',
    'payroll.audit.workflow.cancelled': 'Hủy quy trình xác nhận phiếu lương',
    'payroll.audit.payroll.table_draft_saved': 'Cập nhật bản nháp bảng lương',
    'payroll.audit.payroll.table_draft_created': 'Tạo bản nháp bảng lương',
    'payroll.audit.payroll.period_created': 'Tạo kỳ lương',
    'payroll.audit.payroll.table_created': 'Tạo bảng lương',
    'payroll.audit.payroll.table_staff_added': 'Thêm nhân viên vào bảng lương',
    'payroll.audit.payroll.reopened': 'Mở lại bảng lương',
    'payroll.audit.payroll.locked': 'Khóa bảng lương',
    'payroll.audit.payroll.period_updated': 'Cập nhật kỳ lương',
    'payroll.audit.payroll.period_deleted': 'Xóa kỳ lương',
    'payroll.audit.payroll.period_cancelled': 'Hủy kỳ lương',
    'payroll.audit.payroll.payslip_created': 'Tạo phiếu lương',
    'payroll.audit.payroll.payment_recorded': 'Ghi nhận thanh toán',
    'payroll.audit.payroll.payment_reversed': 'Hoàn thanh toán',
    'payroll.audit.payroll.adjusted': 'Điều chỉnh phiếu lương',
    'payroll.audit.payroll.adjustment_created': 'Thêm {type}',
    'payroll.audit.payroll.adjustment_updated': 'Sửa {type}',
    'payroll.audit.payroll.adjustment_deleted': 'Xóa {type}',
    'payroll.audit.payroll.work_days_updated': 'Sửa ngày công',
    'payroll.audit.payroll.work_minutes_updated': 'Sửa giờ công',
    'payroll.audit.payroll.payslip_finalized': 'Chốt phiếu lương',
    'payroll.no_table_records': 'Chưa có dữ liệu.',
    'payroll.show_payroll_sheet': 'Xem bảng tính lương',
    'payroll.sheet_page_description':
      'Quản lý, theo dõi và thống kê bảng lương nhân viên theo tháng',
    'payroll.sheet_month_title': 'Tháng {month}',
    'payroll.sheet_employee_list': 'Danh sách nhân viên',
    'payroll.sheet_all_employees': 'Tất cả nhân viên',
    'payroll.sheet_add_employee': 'Thêm nhân viên',
    'payroll.sheet_select_new_employees': 'Chọn nhân viên cần thêm',
    'payroll.sheet_no_new_employees': 'Không tìm thấy nhân viên có thể thêm',
    'payroll.sheet_add_employee_hint':
      'Nhân viên được thêm sẽ được kiểm tra công, mức lương và tạo phiếu lương trong bảng này.',
    'payroll.sheet_add_employee_blocked':
      'Chưa thể thêm nhân viên. Hãy xử lý các lý do sau rồi thử lại:',
    'payroll.sheet_staff_added_success': 'Thêm nhân viên vào bảng lương thành công.',
    'payroll.sheet_work_days_updated_success': 'Cập nhật ngày công thành công.',
    'payroll.sheet_allowance_added_success': 'Thêm phụ cấp thành công.',
    'payroll.sheet_bonus_added_success': 'Thêm thưởng thành công.',
    'payroll.sheet_deduction_added_success': 'Thêm giảm trừ thành công.',
    'payroll.sheet_allowance_updated_success': 'Cập nhật phụ cấp thành công.',
    'payroll.sheet_bonus_updated_success': 'Cập nhật tiền thưởng thành công.',
    'payroll.sheet_deduction_updated_success': 'Cập nhật giảm trừ khác thành công.',
    'payroll.sheet_allowance_deleted_success': 'Xóa phụ cấp thành công.',
    'payroll.sheet_bonus_deleted_success': 'Xóa tiền thưởng thành công.',
    'payroll.sheet_deduction_deleted_success': 'Xóa giảm trừ khác thành công.',
    'payroll.cancel_table': 'Hủy bảng lương',
    'payroll.confirm_cancel_table':
      'Bạn có chắc muốn hủy bảng lương này không? Thao tác này không thể hoàn tác.',
    'payroll.cancel_table_reason_required': 'Vui lòng nhập lý do hủy bảng lương.',
    'payroll.cancel_action': 'Hủy',
    'payroll.table_creation_failed': 'Không thể xử lý tạo bảng lương. Vui lòng thử lại.',
    'payroll.table_created_success': 'Thêm bảng lương thành công.',
    'payroll.table_creation_delayed':
      'Tạo bảng lương đang chờ quá lâu. Vui lòng kiểm tra worker xử lý hàng đợi rồi thử lại.',
    'payroll.table_not_created_blocked':
      'Chưa thể tạo bảng lương vì một số nhân viên chưa đủ điều kiện. Xem lý do bên dưới, xử lý rồi thử lại.',
    'payroll.show_daily_reasons': '{count} mục cần kiểm tra · Nhấn để xem',
    'payroll.edit_all_days': 'Sửa các ngày',
    'payroll.edit_attendance_day': 'Sửa giờ công',
    'payroll.unpaid_leave_action': 'Nghỉ không lương',
    'payroll.attendance_day_unavailable':
      'Không tìm thấy ca làm việc có thể chỉnh sửa cho ngày này.',
    'payroll.attendance_day_not_confirmable':
      'Ngày này chưa đủ điều kiện xác nhận công hoặc đã được xác nhận.',
    'payroll.attendance_updated_retry':
      'Đã cập nhật công. Nhấn Thêm bảng lương để kiểm tra lại các lý do bị chặn.',
    'payroll.functions': 'Chức năng',
    'payroll.payslips_not_created_blocked':
      'Bảng lương đã được tạo, nhưng một số phiếu lương chưa tính được. Xem lý do bên dưới và tính lại phiếu còn thiếu sau khi xử lý.',
    'payroll.table_missing_salary':
      'Chưa thể tạo bảng lương: {employees} chưa được thiết lập lương. Mở Quản lý nhân viên → Lương, nhập loại lương và mức lương rồi thử lại.',
    'payroll.payslips_missing_salary':
      'Bảng lương đã được tạo, nhưng chưa tính được phiếu lương của {employees} vì chưa thiết lập lương. Cập nhật loại lương và mức lương, sau đó bấm “Tính lại phiếu lương còn thiếu” trong bảng này.',
    'payroll.errors.salary_not_configured':
      'Chưa thiết lập đầy đủ loại lương và mức lương. Hãy cập nhật trong hồ sơ nhân viên.',
    'payroll.errors.no_standard_work_days':
      'Nhân viên chưa có ca làm việc trong kỳ lương. Hãy kiểm tra lịch làm việc và khoảng ngày của bảng lương.',
    'payroll.errors.table_not_editable':
      'Chỉ có thể thêm nhân viên vào bảng lương đang khóa công và chưa chốt lương.',
    'payroll.errors.staff_already_added': 'Nhân viên đã có trong bảng lương này.',
    'payroll.errors.run_not_editable':
      'Bảng lương đã được duyệt hoặc chốt, không thể thêm nhân viên.',
    'payroll.errors.workflow_not_configured':
      'Cần cấu hình quy trình duyệt trước khi gửi phiếu lương.',
    'payroll.errors.approval_required': 'Phiếu lương chưa hoàn tất quy trình duyệt.',
    'payroll.errors.payslip_not_payable': 'Phiếu lương chưa đủ điều kiện thanh toán.',
    'payroll.errors.payment_exceeds_balance': 'Số tiền thanh toán vượt quá số tiền còn lại.',
    'payroll.errors.advance_payment_invalid_amount': 'Số tiền chi phải từ {minimum} đến {amount}.',
    'payroll.errors.approval_in_progress':
      'Phiếu lương đang trong quy trình duyệt, không thể thay đổi trực tiếp.',
    'payroll.errors.revision_stale': 'Phiếu lương đã có bản mới. Vui lòng tải lại.',
    'payroll.errors.send_not_allowed': 'Trạng thái phiếu hiện tại không cho phép gửi.',
    'payroll.errors.review_required': 'Cần duyệt nội bộ bảng lương trước khi gửi phiếu.',
    'payroll.errors.resolution_required': 'Cần ghi cách xử lý phản hồi trước khi gửi lại.',
    'payroll.errors.action_not_allowed': 'Thao tác không phù hợp với trạng thái phiếu hiện tại.',
    'payroll.errors.invalid_transition':
      'Không thể {action} {item} khi trạng thái hiện tại là {status}. Hãy tải lại trang để xem trạng thái mới nhất.',
    'payroll.errors.unsupported_transition': '{action} không áp dụng cho {item}.',
    'payroll.inputItem.leave': 'đơn nghỉ phép',
    'payroll.inputItem.overtime': 'phiếu tăng ca',
    'payroll.inputItem.advances': 'phiếu ứng lương',
    'payroll.inputItem.allowances': 'phụ cấp',
    'payroll.inputItem.insurance': 'bảo hiểm',
    'payroll.inputItem.payslips': 'phiếu lương',
    'payroll.inputAction.approve': 'duyệt',
    'payroll.inputAction.reject': 'từ chối',
    'payroll.inputAction.cancel': 'hủy',
    'payroll.inputAction.mark-paid': 'đánh dấu đã chi',
    'payroll.inputAction.reverse-payment': 'hoàn tác thanh toán',
    'payroll.inputAction.deactivate': 'ngừng hiệu lực',
    'payroll.inputAction.reactivate': 'kích hoạt lại',
    'payroll.inputAction.reconcile': 'đối soát',
    'payroll.inputAction.edit': 'sửa',
    'payroll.inputAction.delete': 'xóa',
    'payroll.inputStatus.pending': 'chờ duyệt',
    'payroll.inputStatus.approved': 'đã duyệt',
    'payroll.inputStatus.rejected': 'đã từ chối',
    'payroll.inputStatus.cancelled': 'đã hủy',
    'payroll.inputStatus.paid': 'đã chi',
    'payroll.inputStatus.partially_paid': 'đã chi một phần',
    'payroll.inputStatus.active': 'đang hiệu lực',
    'payroll.inputStatus.inactive': 'ngừng hiệu lực',
    'payroll.inputStatus.needs_review': 'cần đối soát lại',
    'payroll.inputStatus.draft': 'nháp',
    'payroll.inputStatus.unknown': 'không xác định',
    'payroll.errors.reason_required': 'Vui lòng nhập lý do.',
    'payroll.errors.not_ready_to_finalize': 'Phiếu lương chưa sẵn sàng để chốt.',
    'payroll.errors.input_changed_recalculate':
      'Dữ liệu tính lương đã thay đổi. Hãy tính lại và kiểm tra số tiền mới trước khi tiếp tục.',
    'payroll.errors.attendance_not_locked_or_changed':
      'Công chưa được khóa hoặc đã thay đổi sau khi khóa. Hãy kiểm tra và khóa lại công trước khi tính lương.',
    'payroll.errors.leave_attendance_conflict':
      'Ngày nghỉ trùng với giờ làm đã ghi nhận. Hãy kiểm tra lại đơn nghỉ và chấm công.',
    'payroll.errors.multiple_insurance_profiles':
      'Có nhiều cấu hình bảo hiểm cùng áp dụng trong kỳ lương. Hãy kiểm tra hồ sơ bảo hiểm của nhân viên.',
    'payroll.errors.social_insurance_profile_conflict':
      'Nhân viên đã có khoản bảo hiểm khấu trừ riêng trong kỳ. Hãy bỏ khoản trùng trước khi tính BHXH từ mức đóng trong hồ sơ nhân viên.',
    'payroll.errors.negative_net_salary':
      'Các khoản khấu trừ vượt quá tiền lương. Hãy kiểm tra các khoản ứng, thuế, bảo hiểm và giảm trừ.',
    'payroll.errors.job_failed_retry':
      'Tạo phiếu lương chưa hoàn tất. Hãy thử tính lại phiếu lương còn thiếu.',
    'payroll.open_staff_salary': 'Cập nhật lương',
    'payroll.retry_missing_payslips': 'Tính lại phiếu lương còn thiếu',
    'payroll.manage_tables': 'Quản lý bảng lương',
    'payroll.view_payslips': 'Phiếu lương',
    'payroll.sheet_base_salary': 'Lương chính',
    'payroll.sheet_addition': 'Tiền thưởng',
    'payroll.sheet_deduction': 'Giảm trừ khác',
    'payroll.sheet_advance': 'Tiền ứng',
    'payroll.sheet_adjustment_total': 'Tổng hiện tại',
    'payroll.sheet_reason': 'Lý do',
    'payroll.sheet_add_bonus': 'Thêm thưởng',
    'payroll.sheet_edit_bonus': 'Sửa tiền thưởng',
    'payroll.sheet_add_deduction': 'Thêm giảm trừ',
    'payroll.sheet_edit_deduction': 'Sửa giảm trừ khác',
    'payroll.sheet_delete_adjustment_confirm': 'Bạn có chắc muốn xóa “{name}” không? Thao tác này không thể hoàn tác.',
    'payroll.sheet_search_employee': 'Tìm theo tên hoặc mã nhân viên',
    'payroll.sheet_all_staff_totals': 'Tổng của toàn bảng lương',
    'payroll.sheet_total_row': 'Tổng cộng',
    'payroll.sheet_total_salary': 'Tổng tiền lương',
    'payroll.sheet_sent_amount': 'Tiền đã gửi',
    'payroll.sheet_remaining_to_send': 'Tiền còn lại phải gửi',
    'payroll.sheet_line_direction': 'Phân loại',
    'payroll.sheet_direction_earning': 'Cộng vào lương',
    'payroll.sheet_direction_deduction': 'Khấu trừ',
    'payroll.sheet_direction_informational': 'Thông tin',
    'payroll.sheet_actual_work_days': 'Số công làm việc thực tế',
    'payroll.sheet_actual_work_time': 'Tổng thời gian làm việc',
    'payroll.sheet_hours_minutes_value': '{hours} giờ {minutes} phút',
    'payroll.sheet_hourly_rate': 'Tiền lương mỗi giờ',
    'payroll.sheet_hourly_earned': 'Lương theo giờ làm',
    'payroll.sheet_payable_hours': 'Số giờ tính lương',
    'payroll.sheet_payable_minutes': 'Số phút',
    'payroll.sheet_work_time_hint':
      'Nhân viên hưởng lương theo giờ. Số công phía trên đếm ngày có làm việc; tiền lương được tính theo tổng giờ và phút. Điều chỉnh này chỉ áp dụng cho phiếu lương, không thay đổi chấm công.',
    'payroll.sheet_reset_work_time': 'Dùng giờ thực tế',
    'payroll.sheet_daily_rate': 'Tiền lương theo công',
    'payroll.sheet_base_earned': 'Lương theo ngày công',
    'payroll.sheet_payable_work_days': 'Số ngày tính công',
    'payroll.sheet_work_days_hint':
      'Số ngày tính công chỉ áp dụng cho phiếu lương này; dữ liệu chấm công thực tế được giữ nguyên.',
    'payroll.sheet_current_total': 'Tổng lương chính hiện tại',
    'payroll.sheet_preview_total': 'Tổng lương chính sau điều chỉnh',
    'payroll.sheet_reset_work_days': 'Dùng công thực tế',
    'payroll.sheet_overtime_hours': 'Số giờ tăng ca',
    'payroll.sheet_overtime_multiplier': 'Hệ số',
    'payroll.sheet_overtime_rate': 'Đơn giá mỗi giờ tăng ca',
    'payroll.sheet_overtime_total': 'Tổng tiền tăng ca',
    'payroll.sheet_allowance_total': 'Tổng phụ cấp',
    'payroll.sheet_paid_amount': 'Tiền đã trả',
    'payroll.sheet_remaining_amount': 'Tiền còn lại',
    'payroll.table_remaining_payable': 'Tiền còn lại phải trả',
    'payroll.payslip_received_amount': 'Đã nhận',
    'payroll.payslip_remaining_amount': 'Còn lại',
    'payroll.payslip_unpaid_balance': 'Còn chưa thanh toán',
    'payroll.sheet_allowance_name': 'Tên phụ cấp',
    'payroll.sheet_allowance_unit_price': 'Đơn giá',
    'payroll.sheet_allowance_quantity': 'Số lượng',
    'payroll.sheet_allowance_unit_day': 'ngày',
    'payroll.sheet_allowance_unit_shift': 'ca',
    'payroll.sheet_allowance_unit_hour': 'giờ',
    'payroll.sheet_allowance_unit_month': 'tháng',
    'payroll.sheet_allowance_unit_item': 'khoản',
    'payroll.sheet_add_allowance': 'Thêm phụ cấp',
    'payroll.sheet_edit_allowance': 'Sửa phụ cấp',
    'payroll.search_table': 'Tìm tên hoặc tháng bảng lương',
    'payroll.table_period_dates': 'Ngày kỳ bảng lương',
    'payroll.table_staff_count': 'Số lượng nhân viên',
    'payroll.create_table': 'Thêm bảng lương',
    'payroll.save_draft': 'Lưu tạm',
    'payroll.edit_draft_table': 'Tiếp tục bảng lương nháp',
    'payroll.table_name': 'Tên bảng lương',
    'payroll.table_name_default': 'Bảng lương {month}',
    'payroll.custom_range': 'Tùy chọn thời gian',
    'payroll.date_from': 'Từ ngày',
    'payroll.date_to': 'Đến ngày',
    'payroll.notes': 'Ghi chú',
    'payroll.select_employees': 'Tùy chọn nhân viên',
    'payroll.select_all_employees': 'Chọn tất cả nhân viên',
    'payroll.select_all_employees_hint':
      'Bảng lương sẽ áp dụng cho tất cả nhân viên trong phạm vi được quản lý.',
    'payroll.table_name_required': 'Vui lòng nhập tên bảng lương.',
    'payroll.period_end_month': 'Tháng kết thúc kỳ lương (YYYY-MM)',
    'payroll.period_start_day': 'Ngày bắt đầu kỳ lương',
    'payroll.period_date_range': 'Khoảng ngày của kỳ lương',
    'payroll.period_cycle_hint':
      'Chọn ngày 1 để dùng tháng dương lịch; ngày khác sẽ tính kỳ từ ngày đó của tháng trước đến ngày liền trước trong tháng đã chọn.',
    'payroll.create_period': 'Tạo kỳ lương',
    'payroll.edit_period': 'Sửa kỳ lương',
    'payroll.delete_period': 'Xóa kỳ lương',
    'payroll.delete_table': 'Xóa bảng lương',
    'payroll.delete_table_confirm':
      'Bạn có chắc muốn xóa bảng lương này không? Thao tác này không thể hoàn tác.',
    'payroll.confirm_delete_period':
      'Bạn có chắc muốn xóa kỳ lương này không? Thao tác này không thể hoàn tác.',
    'payroll.errors.period_not_editable':
      'Chỉ có thể sửa hoặc xóa kỳ lương đang mở. Hãy mở lại công trước.',
    'payroll.errors.period_locked':
      'Kỳ lương của nhân viên này đã khóa công. Hãy mở khóa kỳ lương trước khi sửa chấm công.',
    'payroll.errors.finalized_period_immutable':
      'Không thể mở lại công vì kỳ lương đã có ít nhất một phiếu lương được chốt hoặc đã thanh toán. Dữ liệu công của kỳ này không thể thay đổi.',
    'payroll.errors.period_has_payments':
      'Bảng lương đã có phiếu lương được thanh toán, không thể hủy hoặc xóa.',
    'payroll.errors.period_already_cancelled': 'Bảng lương này đã được hủy trước đó.',
    'payroll.errors.period_cancelled': 'Bảng lương đã bị hủy.',
    'payroll.cancel_table_reason_max_length': 'Lý do hủy không được vượt quá 500 ký tự.',
    'payroll.errors.period_has_payroll_data':
      'Kỳ lương đã có bảng lương hoặc tác vụ tạo phiếu; không thể sửa hay xóa.',
    'payroll.errors.table_not_draft': 'Bảng lương này không còn ở trạng thái nháp để chỉnh sửa.',
    'payroll.errors.draft_must_be_completed':
      'Hãy hoàn tất bảng lương nháp bằng nút Thêm bảng lương.',
    'payroll.errors.staff_selection_required':
      'Vui lòng chọn ít nhất một nhân viên trước khi tạo bảng lương.',
    'payroll.period': 'Kỳ lương',
    'payroll.open': 'Đang mở',
    'payroll.locked': 'Đã khóa công',
    'payroll.lock': 'Khóa công',
    'payroll.reopen': 'Mở lại công',
    'payroll.create_many': 'Tạo phiếu lương',
    'payroll.all_filtered': 'Chọn tất cả theo bộ lọc',
    'payroll.preview': 'Kiểm tra trước khi tạo',
    'payroll.create_eligible': 'Tạo các phiếu hợp lệ',
    'payroll.eligible': 'Đủ điều kiện',
    'payroll.blocked': 'Bị chặn',
    'payroll.already_exists': 'Đã có phiếu',
    'payroll.created': 'Đã tạo',
    'payroll.result': 'Kết quả',
    'payroll.gross': 'Tổng tiền lương',
    'payroll.deductions': 'Khấu trừ',
    'payroll.net': 'Thực nhận',
    'payroll.calculated': 'Đã tính',
    'payroll.reviewed': 'Đã kiểm tra',
    'payroll.finalized': 'Đã chốt',
    'payroll.draft': 'Nháp',
    'payroll.calculate': 'Tính lại',
    'payroll.review': 'Kiểm tra bảng lương',
    'payroll.finalize': 'Chốt bảng lương',
    'payroll.detail': 'Chi tiết',
    'payroll.payslip': 'Phiếu lương',
    'payroll.payslip_detail_title': 'Chi tiết bảng lương',
    'payroll.payslip_document_title': 'Phiếu lương',
    'payroll.payslip_document_sheet': 'Phiếu lương',
    'payroll.payslip_attendance_section': 'Công và thời gian làm việc',
    'payroll.payslip_items_section': 'Các khoản tiền lương',
    'payroll.payslip_deductions_section': 'Các khoản khấu trừ',
    'payroll.payslip_earnings_total': 'Tổng cộng',
    'payroll.payslip_deductions_total': 'Tổng cộng (khấu trừ)',
    'payroll.payslip_net_description': 'Tổng lương sau khi trừ các khoản khấu trừ',
    'payroll.payslip_payment_section': 'Tổng hợp thanh toán',
    'payroll.payslip_worked_time': 'Thời gian thực làm',
    'payroll.payslip_late_time': 'Đi muộn',
    'payroll.payslip_early_time': 'Về sớm',
    'payroll.payslip_overtime_time': 'Thời gian tăng ca',
    'payroll.payslip_overtime_pay': 'Lương tăng ca',
    'payroll.payslip_partially_paid_leave': 'Nửa ngày nghỉ hưởng một phần lương',
    'payroll.payslip_paid_leave_equivalent': 'Nửa ngày nghỉ hưởng lương quy đổi',
    'payroll.payslip_hours_minutes': '{hours} giờ {minutes} phút',
    'payroll.payslip_minutes': '{minutes} phút',
    'payroll.payslip_other_item': 'Khoản khác',
    'payroll.pay': 'Thanh toán',
    'payroll.pay_salary': 'Thanh toán lương',
    'payroll.my_payslips': 'Phiếu lương của tôi',
    'payroll.managed_payslips': 'Phiếu lương quản lý',
    'payroll.approval_workflow': 'Quy trình duyệt phiếu lương',
    'payroll.approval_status': 'Trạng thái duyệt phiếu',
    'payroll.workflow_manager_final': 'Nhân viên chốt, quản lý xác nhận cuối',
    'payroll.workflow_employee_final': 'Nhân viên chốt, chuyển sang thanh toán',
    'payroll.approval_revision': 'Bản gửi',
    'payroll.approval_history': 'Lịch sử duyệt',
    'payroll.send_payslip': 'Gửi phiếu lương',
    'payroll.send_all_payslips': 'Gửi phiếu lương',
    'payroll.sheet_pay_selected': 'Thanh toán ({count})',
    'payroll.sheet_pay_selected_title': 'Thanh toán phiếu lương đã chọn',
    'payroll.sheet_payment_summary': '{count} phiếu lương · Tổng cần thanh toán: {amount}',
    'payroll.sheet_payment_result': 'Đã thanh toán: {paid} · Chưa thanh toán được: {failed}',
    'payroll.sheet_payment_failed': 'Không thể ghi nhận thanh toán.',
    'payroll.sheet_payment_no_methods':
      'Chưa có phương thức thanh toán khả dụng. Hãy cấu hình trong cài đặt hệ thống.',
    'payroll.sheet_retry_payment': 'Thử lại phiếu chưa thanh toán',
    'payroll.sheet_review_confirm':
      'Xác nhận đã kiểm tra toàn bộ phiếu lương trong bảng này? Sau khi kiểm tra, bạn có thể gửi phiếu cho nhân viên.',
    'payroll.sheet_recalculate': 'Tính lại bảng lương',
    'payroll.sheet_recalculate_confirm':
      'Tính lại toàn bộ phiếu theo dữ liệu mới nhất? Số tiền trong bảng có thể thay đổi. Hãy kiểm tra lại trước khi duyệt và gửi.',
    'payroll.sheet_recalculate_after_error':
      'Dữ liệu đã thay đổi. Hãy tính lại bảng lương, kiểm tra số tiền mới rồi duyệt.',
    'payroll.sheet_recalculated_review_hint':
      'Đã tính lại bảng lương. Hãy kiểm tra số tiền mới trước khi duyệt và gửi phiếu.',
    'payroll.send_all_payslips_confirm':
      'Gửi phiếu lương cho tất cả {count} nhân viên trong bảng này? Phiếu đã gửi sẽ được bỏ qua.',
    'payroll.send_all_payslips_result':
      'Đã gửi: {sent} · Đã gửi trước đó: {skipped} · Chưa gửi được: {blocked}',
    'payroll.approve_payslip': 'Xác nhận thông tin',
    'payroll.request_payslip_changes': 'Yêu cầu chỉnh sửa',
    'payroll.manager_final_approve': 'Quản lý xác nhận cuối',
    'payroll.return_payslip_for_changes': 'Trả phiếu để chỉnh sửa',
    'payroll.cancel_payslip_approval': 'Hủy quy trình phiếu',
    'payroll.approval.not_sent': 'Chưa gửi',
    'payroll.approval.awaiting_employee': 'Chờ nhân viên xác nhận',
    'payroll.approval.changes_requested': 'Cần xử lý phản hồi',
    'payroll.approval.awaiting_manager_final': 'Chờ quản lý xác nhận cuối',
    'payroll.approval.payable': 'Đủ điều kiện thanh toán',
    'payroll.approval.cancelled': 'Đã hủy',
    'payroll.approval_event.sent': 'Đã gửi phiếu',
    'payroll.approval_event.employee_approved': 'Nhân viên xác nhận',
    'payroll.approval_event.changes_requested': 'Nhân viên yêu cầu sửa',
    'payroll.approval_event.manager_final_approved': 'Quản lý xác nhận cuối',
    'payroll.approval_event.returned_for_changes': 'Quản lý trả phiếu để sửa',
    'payroll.approval_event.cancelled': 'Đã hủy quy trình phiếu',
    'payroll.approval_action.send': 'Gửi phiếu lương',
    'payroll.approval_action.approve': 'Xác nhận phiếu lương',
    'payroll.approval_action.request-changes': 'Yêu cầu chỉnh sửa',
    'payroll.approval_action.manager-final-approve': 'Xác nhận cuối',
    'payroll.approval_action.return-for-changes': 'Trả phiếu để chỉnh sửa',
    'payroll.approval_action.cancel-approval': 'Hủy quy trình phiếu',
    'payroll.approval_confirm.send': 'Gửi bản phiếu lương hiện tại cho nhân viên?',
    'payroll.approval_confirm.approve': 'Xác nhận thông tin trên bản phiếu lương này?',
    'payroll.approval_confirm.manager-final-approve':
      'Xác nhận cuối và cho phép thanh toán phiếu này?',
    'payroll.reverse_payment': 'Đảo giao dịch',
    'payroll.base_salary': 'Lương theo công',
    'payroll.work_day_breakdown_title': 'Chi tiết ngày bị giảm công',
    'payroll.leave_for_shift': 'Xin nghỉ cho ca: {shift}',
    'payroll.work_day_breakdown_legacy_notice': 'Phiếu lương này được tạo trước khi hệ thống lưu chi tiết ngày bị giảm công. Hãy tính lại bảng lương để xem đầy đủ ngày và lý do.',
    'payroll.work_day_worked_time': 'Thời gian thực tế / ca',
    'payroll.work_day_credited': 'Công được tính',
    'payroll.work_day_deducted': 'Công bị giảm',
    'payroll.work_day_reason.missing_check_in': 'Thiếu giờ vào',
    'payroll.work_day_reason.missing_check_out': 'Thiếu giờ ra',
    'payroll.work_day_reason.late': 'Đi trễ',
    'payroll.work_day_reason.early_leave': 'Về sớm',
    'payroll.work_day_reason.insufficient_work_time': 'Thời gian làm việc chưa đủ ca',
    'payroll.paid_leave': 'Lương nghỉ phép',
    'payroll.allowance': 'Phụ cấp',
    'payroll.advance': 'Ứng đã chi',
    'payroll.employer_insurance': 'Bảo hiểm doanh nghiệp đóng',
    'payroll.confirm_attendance': 'Xác nhận công',
    'payroll.confirm_selected': 'Xác nhận',
    'payroll.confirm_all': 'Xác nhận tất cả ngày hợp lệ',
    'payroll.date': 'Ngày',
    'payroll.unconfirmed': 'Chưa xác nhận',
    'payroll.confirmed': 'Đã xác nhận',
    'payroll.changed_after_confirmation': 'Công đã thay đổi, cần xác nhận lại',
    'payroll.not_required': 'Không cần xác nhận',
    'payroll.minutes_per_day': 'Số phút chuẩn mỗi ngày',
    'payroll.rounding_minutes': 'Bước làm tròn phút',
    'payroll.rounding_mode': 'Cách làm tròn',
    'payroll.nearest': 'Gần nhất',
    'payroll.down': 'Làm tròn xuống',
    'payroll.up': 'Làm tròn lên',
    'payroll.half_day_threshold_percent': 'Ngưỡng nửa công (%)',
    'payroll.full_day_threshold_percent': 'Ngưỡng đủ công (%)',
    'payroll.confirmation_deadline_day': 'Hạn xác nhận (Để trống = cuối tháng)',
    'payroll.selection_changed': 'Hãy kiểm tra lại sau khi đổi danh sách nhân viên.',
    'payroll.confirm_hint':
      'Kiểm tra lịch sử công trước khi xác nhận. Nếu sai, gửi yêu cầu chỉnh công ở chi tiết ngày.',
    'payroll.confirm_prompt': 'Xác nhận các ngày đã chọn là chính xác?',
    'payroll.confirm_for_staff_prompt':
      'Bạn đang xác nhận công thay cho {name}. Các ngày đã chọn là chính xác?',
    'payroll.error_required': 'Vui lòng nhập đủ thông tin bắt buộc.',
    'payroll.errors.advance_end_before_start':
      'Đến ngày ({end}) đang trước Từ ngày ({start}). Vui lòng chọn lại Đến ngày.',
    'payroll.errors.insufficient_leave_quota':
      'Không thể duyệt phiếu vì nhân viên không còn đủ hạn mức. Hãy bật tùy chọn chuyển sang nghỉ không lương hoặc cấp thêm phép.',
    'payroll.errors.attendance_not_ended': 'Ca làm việc chưa kết thúc.',
    'payroll.errors.attendance_missing_check_in': 'Thiếu giờ vào ca.',
    'payroll.errors.attendance_missing_check_out': 'Đã vào ca nhưng chưa có giờ ra.',
    'payroll.errors.attendance_unmatched': 'Dữ liệu chấm công chưa khớp với ca làm việc.',
    'payroll.errors.attendance_ambiguous': 'Không xác định được dữ liệu chấm công thuộc ca nào.',
    'payroll.errors.adjustment_pending': 'Có yêu cầu điều chỉnh chấm công đang chờ xử lý.',
    'payroll.errors.leave_pending': 'Có đơn nghỉ đang chờ duyệt.',
    'payroll.errors.faceid_pending': 'Có dữ liệu nhận diện khuôn mặt đang chờ xử lý.',
    'payroll.errors.overtime_pending': 'Có phiếu tăng ca đang chờ duyệt.',
    'payroll.errors.overtime_needs_review': 'Có phiếu tăng ca cần kiểm tra lại.',
    'payroll.errors.overtime_delete_pending_only': 'Chỉ có thể xóa phiếu tăng ca đang chờ duyệt.',
    'payroll.errors.attendance_unconfirmed': 'Chưa được nhân viên xác nhận công.',
    'payroll.errors.attendance_changed_after_confirmation':
      'Công đã thay đổi sau khi xác nhận, cần xác nhận lại.',
    'payroll.errors.adjustment_rejected':
      'Yêu cầu điều chỉnh chấm công bị từ chối, cần kiểm tra lại.',
    'payroll.errors.leave_quota_exhausted':
      'Loại nghỉ này đã hết phép. Vui lòng chọn loại nghỉ khác.',
    'payroll.errors.insufficient_leave_quota_to_request':
      'Số ngày phép còn lại không đủ để tạo phiếu nghỉ này.',
    'payroll.errors.leave_requires_schedule':
      'Nhân viên chưa có ca làm việc trong khoảng thời gian xin nghỉ.',
    'payroll.errors.system_leave_type_immutable':
      'Loại Nghỉ không lương mặc định của hệ thống không thể chỉnh sửa.',
    'payroll.errors.leave_type_in_use':
      'Không thể xóa loại nghỉ vì đã phát sinh đơn nghỉ hoặc dữ liệu hạn mức.',
    'payroll.errors.allowance_type_in_use':
      'Không thể xóa loại phụ cấp vì đã phát sinh dữ liệu phụ cấp.',
    'payroll.errors.reversal_details_required':
      'Vui lòng nhập lý do trước khi hoàn tác lần chi gần nhất.',
    'payroll.errors.reconciliation_reason_required':
      'Vui lòng nhập lý do đối soát.',
    'payroll.errors.leave_quota_balance_negative':
      'Không thể cập nhật vì số phép còn lại của nhân viên sẽ âm.',
    'payroll.errors.staff_must_be_active_to_update_leave_quota':
      'Chỉ có thể cập nhật số ngày phép cho nhân viên đang hoạt động.',
    'payroll.errors.overtime_end_after_start':
      'Thời gian kết thúc tăng ca phải sau thời gian bắt đầu. Nếu tăng ca qua đêm, hãy chọn ngày kết thúc là ngày hôm sau.',
    'payroll.errors.overtime_exceeds_24_hours': 'Một phiếu tăng ca không được vượt quá 24 giờ.',
    'payroll.errors.invalid_overtime_range':
      'Khoảng thời gian tăng ca không hợp lệ. Thời gian kết thúc phải sau thời gian bắt đầu và tổng thời gian không được vượt quá 24 giờ.',
    'payroll.errors.invalid_table_range':
      'Khoảng ngày không hợp lệ. Ngày kết thúc phải sau hoặc bằng ngày bắt đầu.',
    'payroll.errors.table_range_conflict':
      'Đã có bảng lương khác cho tháng kết thúc này với khoảng ngày khác.',
    'payroll.errors.table_already_exists':
      'Bảng lương cho khoảng ngày này đã được tạo với thông tin hoặc danh sách nhân viên khác.',
    'payroll.errors.overtime_overlaps_shift':
      'Khoảng thời gian tăng ca đang trùng với ca làm việc của nhân viên. Vui lòng chọn thời gian ngoài ca.',
    'payroll.errors.overtime_shift_required': 'Vui lòng chọn ca làm việc trước khi nhập tăng ca.',
    'payroll.errors.overtime_not_after_selected_shift':
      'Thời gian tăng ca phải bắt đầu từ lúc ca đã chọn kết thúc và không cách quá 24 giờ.',
    'payroll.errors.payroll_input_overlap':
      'Khoảng thời gian này đang trùng với một phiếu đã tồn tại.',
    'payroll.errors.staff_allowance_assignment_overlap':
      'Nhân viên đã được áp dụng phụ cấp này trong cùng khoảng thời gian.',
    'payroll.leave_create_success': 'Tạo phiếu nghỉ phép thành công.',
    'payroll.leave_create_failure': 'Tạo phiếu nghỉ phép không thành công.',
    'payroll.overtime_create_success': 'Thêm phiếu tăng ca thành công.',
    'payroll.allowance_create_failure': 'Thêm phụ cấp không thành công.',
    'payroll.allowance_create_success': 'Thêm phụ cấp thành công.',
    'payroll.overtime_create_failure': 'Thêm phiếu tăng ca không thành công.',
    'payroll.advance_create_success': 'Tạo phiếu ứng lương thành công.',
    'payroll.advance_create_failure': 'Tạo phiếu ứng lương không thành công.',
    'payroll.period_hint':
      'Khóa công sau khi nhân viên xác nhận. Các ngày bị thay đổi hoặc có yêu cầu chờ duyệt sẽ chặn khóa công.',
    'payroll.print': 'In / lưu PDF',
    'payroll.retry_blocked': 'Kiểm tra lại các dòng bị chặn',
    'payroll.adjust': 'Điều chỉnh phiếu',
    'payroll.adjustment_type': 'Loại điều chỉnh',
    'payroll.addition': 'Cộng thêm',
    'payroll.deduction': 'Khấu trừ khác',
    'payroll.tax': 'Thuế nhập thủ công',
    'payroll.export': 'Xuất Excel',
    'payroll.standard_days': 'Công chuẩn',
    'payroll.actual_work_days': 'Số công thực tế',
    'payroll.payable_work_days': 'Số công tính lương',
    'payroll.manual_work_days': 'Số công điều chỉnh',
    'payroll.manual_work_minutes': 'Thời gian làm việc điều chỉnh',
    'payroll.work_day_rate': 'Đơn giá ngày công',
    'payroll.worked_half_days': 'Nửa ngày thực làm',
    'payroll.worked_minutes': 'Phút thực làm',
    'payroll.late_minutes': 'Thời gian đi trễ',
    'payroll.early_leave_minutes': 'Thời gian về sớm',
    'payroll.paid_leave_half_days': 'Nửa ngày nghỉ hưởng lương',
    'payroll.partially_paid_leave_half_days': 'Nửa ngày nghỉ hưởng một phần lương',
    'payroll.paid_leave_equivalent_half_days': 'Nửa ngày nghỉ quy đổi hưởng lương',
    'payroll.unpaid_leave_half_days': 'Nửa ngày nghỉ không lương',
    'payroll.absent_half_days': 'Nửa ngày thiếu công',
    'payroll.overtime_minutes': 'Phút tăng ca',
    'payroll.notification.attendance.changed_after_confirmation':
      'Dữ liệu công đã thay đổi sau khi xác nhận. Vui lòng kiểm tra và xác nhận lại.',
    'payroll.notification.leave.approved': 'Đơn nghỉ của bạn đã được duyệt.',
    'payroll.notification.leave.rejected': 'Đơn nghỉ của bạn đã bị từ chối.',
    'payroll.notification.overtime.approved': 'Phiếu tăng ca của bạn đã được duyệt.',
    'payroll.notification.overtime.rejected': 'Phiếu tăng ca của bạn đã bị từ chối.',
    'payroll.notification.advances.approved': 'Đề nghị ứng lương của bạn đã được duyệt.',
    'payroll.notification.advances.rejected': 'Đề nghị ứng lương của bạn đã bị từ chối.',
    'payroll.notification.payroll.attendance_reopened':
      'Kỳ công đã được mở lại. Vui lòng kiểm tra dữ liệu công.',
    'payroll.notification.payroll.payslip_finalized':
      'Phiếu lương đã được chốt. Đăng nhập để xem chi tiết.',
    'payroll.notification.payroll.payslip_sent':
      'Bạn có phiếu lương mới. Đăng nhập để kiểm tra và xác nhận.',
    'payroll.notification.payroll.payslip_feedback':
      'Nhân viên đã yêu cầu chỉnh sửa phiếu lương. Đăng nhập để xử lý.',
    'payroll.notification.payroll.payslip_employee_approved':
      'Nhân viên đã xác nhận phiếu lương. Đăng nhập để kiểm tra bước tiếp theo.',
    'payroll.notification.payroll.payslip_returned':
      'Phiếu lương đang được xem lại. Bạn sẽ nhận được bản mới sau khi xử lý.',
    'payroll.notification.payroll.payslip_cancelled':
      'Quy trình phiếu lương đã được hủy. Đăng nhập để xem chi tiết.',
    'payroll.notification.payroll.payment_recorded':
      'Lương đã được ghi nhận thanh toán. Đăng nhập để xem chi tiết.',
    'payroll.notification.attendance.confirmation_deadline':
      'Sắp đến hạn xác nhận công. Vui lòng kiểm tra và xác nhận các ngày còn thiếu.',
  },
  en: {
    'payroll.table_create_failed_notice': 'Failed to add payroll table.',
    'payroll.queued': 'Queued',
    'payroll.processing': 'Creating payslips',
    'payroll.completed': 'Completed',
    'payroll.failed': 'Failed; preview and retry missing payslips',
    'payroll.reconcile': 'Reconcile again',
    'payroll.needs_review': 'Needs reconciliation',
    'payroll.adjustment_pending': 'Adjustment pending',
    'payroll.adjustment_rejected': 'Adjustment rejected',
    'payroll.ignore_attendance': 'Ignore record',
    'payroll.ignore': 'Ignore unscheduled attendance',
    'payroll.approve_unscheduled': 'Approve unscheduled work',
    'payroll.assignment': 'Assigned shift',
    'payroll.check_in': 'Check-in',
    'payroll.check_out': 'Check-out',
    'payroll.reconcile_hint':
      'Choose a matching shift for unscheduled attendance. Original punches are preserved.',
    'payroll.leave': 'Leave',
    'payroll.overtime': 'Overtime requests',
    'payroll.allowances': 'Allowances',
    'payroll.allowance_types': 'Allowance catalog',
    'payroll.allowance_type_create_title': 'Add allowance type',
    'payroll.allowance_type_edit_title': 'Update allowance type',
    'payroll.allowance_type_update_success': 'Allowance type restored successfully.',
    'payroll.advances': 'Salary advances',
    'payroll.insurance': 'Insurance',
    'payroll.insurance_settings_staff_tab': 'Employee contribution settings',
    'payroll.insurance_settings_records_tab': 'Insurance records by period',
    'payroll.insurance_settings_edit_title': 'Employee insurance settings',
    'payroll.insurance_settings_update_success':
      'Employee insurance settings updated successfully.',
    'payroll.insurance_deactivate_success': 'Insurance record deactivated successfully.',
    'payroll.insurance_deactivate_failure': 'Failed to deactivate insurance record.',
    'payroll.insurance_settings_bulk_edit': 'Edit',
    'payroll.insurance_settings_bulk_title': 'Bulk edit insurance settings',
    'payroll.insurance_settings_selected_count': '{count} employees selected',
    'payroll.insurance_settings_use_monthly_salary':
      'Use monthly salary as the social insurance base',
    'payroll.insurance_settings_monthly_salary_unavailable':
      '{count} employees do not have a monthly salary. Set their monthly salary before using this option.',
    'payroll.insurance_settings_health': 'Health insurance',
    'payroll.insurance_settings_unemployment': 'Unemployment insurance',
    'payroll.insurance_settings_records_hint':
      'Period records are for separate insurance deductions. An overlapping deduction blocks payslip calculation when the employee already has a contribution base in the other tab.',
    'payroll.social_insurance': 'Employee social insurance (8%)',
    'payroll.social_insurance_elsewhere': 'Social insurance deducted on another payslip this month',
    'payroll.health_insurance': 'Employee health insurance (1.5%)',
    'payroll.health_insurance_elsewhere': 'Health insurance deducted on another payslip this month',
    'payroll.unemployment_insurance': 'Employee unemployment insurance (1%)',
    'payroll.unemployment_insurance_elsewhere':
      'Unemployment insurance deducted on another payslip this month',
    'payroll.title': 'Payroll',
    'payroll.staff': 'Employee',
    'payroll.search': 'Search employee code or name',
    'payroll.mine': 'My requests',
    'payroll.all': 'All',
    'payroll.pending': 'Pending',
    'payroll.approved': 'Approved',
    'payroll.approved_paid': 'Approved / Disbursed',
    'payroll.rejected': 'Rejected',
    'payroll.rejected_cancelled': 'Rejected / Cancelled',
    'payroll.cancelled': 'Cancelled',
    'payroll.active': 'Active',
    'payroll.inactive': 'Inactive',
    'payroll.status_active': 'Active',
    'payroll.status_locked': 'Suspended',
    'payroll.paid': 'Paid',
    'payroll.reversed': 'Reversed',
    'payroll.partially_paid': 'Partially disbursed',
    'payroll.allocated': 'Fully allocated',
    'payroll.status': 'Status',
    'payroll.starts_on': 'From',
    'payroll.ends_on': 'To',
    'payroll.reason': 'Reason',
    'payroll.actions': 'Actions',
    'payroll.cancelled_reason_detail': 'Cancellation reason: {reason}',
    'payroll.rejected_reason_detail': 'Rejection reason: {reason}',
    'payroll.amount': 'Amount',
    'payroll.amount_override': 'Custom allowance amount',
    'payroll.allowance_type_id': 'Allowance type',
    'payroll.note': 'Note',
    'payroll.description': 'Description',
    'payroll.calculation_basis': 'Calculation basis',
    'payroll.default_amount': 'Default amount',
    'payroll.require_check_in': 'Require check-in',
    'payroll.require_check_out': 'Require check-out',
    'payroll.minimum_worked_minutes': 'Minimum worked minutes',
    'payroll.count_paid_leave': 'Count paid leave',
    'payroll.effective_from': 'Effective from',
    'payroll.effective_to': 'Effective to',
    'payroll.name': 'Name',
    'payroll.frequency': 'Frequency',
    'payroll.daily': 'Daily',
    'payroll.monthly': 'Monthly',
    'payroll.eligibility': 'Eligibility',
    'payroll.worked_day': 'Worked days',
    'payroll.paid_day': 'Worked and paid leave days',
    'payroll.attendance_day': 'Attendance days',
    'payroll.taxable': 'Taxable',
    'payroll.prorate_on_join': 'Prorate when joining mid-period',
    'payroll.prorate_on_leave': 'Prorate when leaving mid-period',
    'payroll.yes': 'Yes',
    'payroll.no': 'No',
    'payroll.half_day': 'Leave duration',
    'payroll.leave_hours': 'Leave hours',
    'payroll.leave_hour_option': '{hours} hours ({ratio} day)',
    'payroll.full': 'Full day',
    'payroll.morning': 'Morning',
    'payroll.afternoon': 'Afternoon',
    'payroll.leave_type': 'Leave type',
    'payroll.leave_types': 'Leave types and quota',
    'payroll.leave_types_subtitle': 'Configure leave types and usage quotas',
    'payroll.leave_type_list': 'Leave type list',
    'payroll.add_leave_type': 'Add leave type',
    'payroll.leave_type_create_title': 'Add leave type',
    'payroll.leave_type_edit_title': 'Update leave type',
    'payroll.system_default': 'System default',
    'payroll.convert_to_unpaid': 'Convert to unpaid leave when quota is insufficient',
    'payroll.convert_to_unpaid_hint':
      'If the quota is insufficient, the entire request will be approved as unpaid leave without using the remaining quota.',
    'payroll.quota_form_title': 'Grant leave quota',
    'payroll.quota_form_edit_title': 'Update saved leave grant',
    'payroll.quota_grant_list': 'Saved grants',
    'payroll.granted_at': 'Granted at',
    'payroll.check_balance': 'Check balance',
    'payroll.edit': 'Edit',
    'payroll.delete_leave_type': 'Delete leave type',
    'payroll.delete_leave_type_confirm':
      'Delete leave type “{name}”? This action cannot be undone.',
    'payroll.delete_allowance_type': 'Delete allowance type',
    'payroll.delete_allowance_type_confirm':
      'Delete allowance type “{name}”? This action cannot be undone.',
    'payroll.cancel_edit': 'Cancel editing',
    'payroll.code': 'Code',
    'payroll.pay_ratio': 'Pay ratio (%)',
    'payroll.deduct_quota': 'Deduct quota',
    'payroll.allow_half_day': 'Allow hourly / half-day leave',
    'payroll.half_days': 'Half days',
    'payroll.leave_days': 'Leave days',
    'payroll.days_remaining': 'days remaining',
    'payroll.unlimited': 'Unlimited',
    'payroll.leave_quota_loading': 'Loading the remaining leave balance. Please wait.',
    'payroll.half_days_to_grant': 'Half days to grant',
    'payroll.days_to_grant': 'Days to grant',
    'payroll.select_staff': 'Select employees',
    'payroll.selected_staff': 'Selected employees',
    'payroll.no_staff_selected': 'No employees selected',
    'payroll.confirm_selection': 'Confirm selection',
    'payroll.employee_code': 'Employee code',
    'payroll.employee_name': 'Employee name',
    'payroll.lock_blocked_days': 'Days to resolve (click to open attendance confirmation)',
    'payroll.open_attendance_history': 'Attendance history',
    'payroll.lock_ready': 'All employees meet the requirements. You can save to lock attendance.',
    'payroll.department': 'Department',
    'payroll.staff_department': 'Department',
    'payroll.work_shift': "Today's work shift",
    'payroll.source_shift': 'Shift before overtime',
    'payroll.no_overtime_shift_options':
      'No common shift type is available. Select employees on the same shift or create separate requests.',
    'payroll.remove_staff': 'Remove employee',
    'payroll.remaining_leave_days': 'Remaining leave (days)',
    'payroll.quota': 'Grant leave',
    'payroll.balance': 'Remaining half days',
    'payroll.starts_at': 'Overtime start',
    'payroll.ends_at': 'Overtime end',
    'payroll.approved_starts_at': 'Approved overtime start',
    'payroll.approved_ends_at': 'Approved overtime end',
    'payroll.override_reason': 'Reason for approving beyond the request',
    'payroll.multiplier_percent': 'Multiplier (%)',
    'payroll.deduction_month': 'Deduction month (YYYY-MM)',
    'payroll.no_matching_assignment': 'No unused shift is available for this day',
    'payroll.advance_policy': 'Salary advance eligibility',
    'payroll.advance_policy_update_success': 'Advance policy updated successfully.',
    'payroll.salary_advance_min_workdays': 'Minimum monthly workdays',
    'payroll.advance_policy_hint': 'Set to 0 to disable the workday threshold.',
    'payroll.advance_eligibility_summary':
      'Current: {current} · Required: {required} · Missing: {missing}',
    'payroll.number': 'Insurance number',
    'payroll.insurance_number': 'Insurance number',
    'payroll.base': 'Insurance salary base',
    'payroll.insurance_base': 'Insurance salary base',
    'payroll.employee_basis_points': 'Employee rate (%)',
    'payroll.employer_basis_points': 'Employer rate (%)',
    'payroll.employee_amount': 'Fixed employee contribution',
    'payroll.employer_amount': 'Fixed employer contribution',
    'payroll.approve': 'Approve',
    'payroll.reject': 'Reject',
    'payroll.cancel': 'Cancel request',
    'payroll.input_action_success': '{action} {record} completed successfully.',
    'payroll.input_action_failure': '{action} {record} failed.',
    'payroll.input_action.approve': 'Approval of',
    'payroll.input_action.reject': 'Rejection of',
    'payroll.input_action.cancel': 'Cancellation of',
    'payroll.input_action.mark_paid': 'Payment recording for',
    'payroll.input_action.reverse_payment': 'Latest disbursement reversal for',
    'payroll.input_action.deactivate': 'Deactivation of',
    'payroll.input_action.reactivate': 'Reactivation of',
    'payroll.input_action.reconcile': 'Reconciliation of',
    'payroll.input_action.record.leave': 'leave request',
    'payroll.input_action.record.overtime': 'overtime request',
    'payroll.input_action.record.allowance_request': 'allowance request',
    'payroll.input_action.record.allowance': 'allowance',
    'payroll.input_action.record.advance': 'salary advance request',
    'payroll.delete_overtime': 'Delete overtime request',
    'payroll.overtime_delete_confirm': 'Are you sure you want to delete this overtime request?',
    'payroll.overtime_delete_success': 'Overtime request deleted.',
    'payroll.overtime_delete_failure': 'Could not delete overtime request.',
    'payroll.cancel_overtime': 'Cancel',
    'payroll.mark-paid': 'Record disbursement',
    'payroll.reverse-payment': 'Reverse latest disbursement',
    'payroll.disbursed': 'Disbursed',
    'payroll.advance_payment_limit':
      'You can disburse up to {amount} this time. The minimum is {minimum}.',
    'payroll.allocated': 'Allocated',
    'payroll.remaining': 'Remaining',
    'payroll.deactivate': 'Deactivate',
    'payroll.reactivate': 'Reactivate',
    'payroll.reactivate_effective_on': 'Reactivate from',
    'payroll.method': 'Payment method',
    'payroll.reference': 'Reference',
    'payroll.confirm': 'Confirm',
    'payroll.month': 'Payroll month (YYYY-MM)',
    'payroll.table': 'Payroll table',
    'payroll.table_details': 'Payroll table details',
    'payroll.created_by': 'Created by',
    'payroll.table_payslips': 'Employee payslips',
    'payroll.table_payment_history': 'Payment history',
    'payroll.audit.history': 'Activity history',
    'payroll.audit.description': 'Review when the payslip changed, who made the change, and what was updated.',
    'payroll.audit.period_description': 'Review when payroll table and payslip actions occurred and who performed them.',
    'payroll.audit.empty': 'No activity yet.',
    'payroll.audit.load_more': 'Load more',
    'payroll.audit.unknown_actor': 'Unknown user',
    'payroll.audit.staff': 'Employee',
    'payroll.audit.adjustment': 'Adjustment',
    'payroll.audit.adjustment_after': 'After update',
    'payroll.audit.payment': 'Payment amount',
    'payroll.audit.reference': 'Reference',
    'payroll.audit.reason': 'Reason',
    'payroll.audit.fields.gross': 'Gross earnings',
    'payroll.audit.fields.deductions': 'Total deductions',
    'payroll.audit.fields.net': 'Net pay',
    'payroll.audit.fields.manual_work_days': 'Work days counted',
    'payroll.audit.fields.manual_work_minutes': 'Adjusted work time (minutes)',
    'payroll.audit.workflow.sent': 'Payslip sent',
    'payroll.audit.workflow.employee_approved': 'Payslip approved by employee',
    'payroll.audit.workflow.changes_requested': 'Changes requested by employee',
    'payroll.audit.workflow.manager_final_approved': 'Payslip finalized by manager',
    'payroll.audit.workflow.returned_for_changes': 'Payslip returned for changes',
    'payroll.audit.workflow.cancelled': 'Payslip approval cancelled',
    'payroll.audit.payroll.table_draft_saved': 'Updated payroll draft',
    'payroll.audit.payroll.table_draft_created': 'Created payroll draft',
    'payroll.audit.payroll.period_created': 'Created payroll period',
    'payroll.audit.payroll.table_created': 'Created payroll table',
    'payroll.audit.payroll.table_staff_added': 'Added staff to payroll table',
    'payroll.audit.payroll.reopened': 'Reopened payroll table',
    'payroll.audit.payroll.locked': 'Locked payroll table',
    'payroll.audit.payroll.period_updated': 'Updated payroll period',
    'payroll.audit.payroll.period_deleted': 'Deleted payroll period',
    'payroll.audit.payroll.period_cancelled': 'Cancelled payroll period',
    'payroll.audit.payroll.payslip_created': 'Created payslip',
    'payroll.audit.payroll.payment_recorded': 'Recorded payment',
    'payroll.audit.payroll.payment_reversed': 'Reversed payment',
    'payroll.audit.payroll.adjusted': 'Adjusted payslip',
    'payroll.audit.payroll.adjustment_created': 'Add {type}',
    'payroll.audit.payroll.adjustment_updated': 'Edit {type}',
    'payroll.audit.payroll.adjustment_deleted': 'Delete {type}',
    'payroll.audit.payroll.work_days_updated': 'Updated work days',
    'payroll.audit.payroll.work_minutes_updated': 'Updated work minutes',
    'payroll.audit.payroll.payslip_finalized': 'Finalized payslip',
    'payroll.no_table_records': 'No records yet.',
    'payroll.show_payroll_sheet': 'View payroll calculation',
    'payroll.sheet_page_description': 'Manage, track and review employee payroll by month',
    'payroll.sheet_month_title': 'Month {month}',
    'payroll.sheet_employee_list': 'Employee list',
    'payroll.sheet_all_employees': 'All employees',
    'payroll.sheet_add_employee': 'Add employees',
    'payroll.sheet_select_new_employees': 'Select employees to add',
    'payroll.sheet_no_new_employees': 'No eligible employees found',
    'payroll.sheet_add_employee_hint':
      'New employees are checked for attendance and salary before their payslips are added to this table.',
    'payroll.sheet_add_employee_blocked':
      'These employees cannot be added yet. Resolve the following issues and try again:',
    'payroll.sheet_staff_added_success': 'Employees added to the payroll table successfully.',
    'payroll.sheet_work_days_updated_success': 'Work days updated successfully.',
    'payroll.sheet_allowance_added_success': 'Allowance added successfully.',
    'payroll.sheet_bonus_added_success': 'Bonus added successfully.',
    'payroll.sheet_deduction_added_success': 'Deduction added successfully.',
    'payroll.sheet_allowance_updated_success': 'Allowance updated successfully.',
    'payroll.sheet_bonus_updated_success': 'Bonus updated successfully.',
    'payroll.sheet_deduction_updated_success': 'Other deduction updated successfully.',
    'payroll.sheet_allowance_deleted_success': 'Allowance deleted successfully.',
    'payroll.sheet_bonus_deleted_success': 'Bonus deleted successfully.',
    'payroll.sheet_deduction_deleted_success': 'Other deduction deleted successfully.',
    'payroll.cancel_table': 'Cancel payroll table',
    'payroll.confirm_cancel_table':
      'Are you sure you want to cancel this payroll table? This cannot be undone.',
    'payroll.cancel_table_reason_required': 'Enter a reason for cancelling this payroll table.',
    'payroll.cancel_action': 'Cancel',
    'payroll.table_creation_failed': 'Could not create the payroll table. Please try again.',
    'payroll.table_created_success': 'Payroll table added successfully.',
    'payroll.table_creation_delayed':
      'Payroll table creation is taking too long. Check the queue worker, then try again.',
    'payroll.table_not_created_blocked':
      'The payroll table could not be created because some employees are not eligible. Review the reasons below, resolve them, and try again.',
    'payroll.show_daily_reasons': '{count} issues · Select to view',
    'payroll.edit_all_days': 'Edit days',
    'payroll.edit_attendance_day': 'Edit attendance',
    'payroll.unpaid_leave_action': 'Unpaid leave',
    'payroll.attendance_day_unavailable': 'No editable shift was found for this day.',
    'payroll.attendance_day_not_confirmable':
      'This day is not eligible for confirmation or is already confirmed.',
    'payroll.attendance_updated_retry':
      'Attendance updated. Select Add payroll table to recheck blocked reasons.',
    'payroll.functions': 'Functions',
    'payroll.payslips_not_created_blocked':
      'The payroll table was created, but some payslips could not be calculated. Review the reasons below and retry the missing payslips after resolving them.',
    'payroll.table_missing_salary':
      'The payroll table could not be created: {employees} have no salary configuration. Open Staff management → Salary, enter the salary type and amount, then try again.',
    'payroll.payslips_missing_salary':
      'The payroll table was created, but payslips for {employees} could not be calculated because salary is not configured. Enter their salary type and amount, then select “Calculate missing payslips” in this table.',
    'payroll.errors.salary_not_configured':
      'Salary type or amount is missing. Update the employee’s salary details.',
    'payroll.errors.no_standard_work_days':
      'The employee has no scheduled shifts in this payroll period. Check the work schedule and payroll dates.',
    'payroll.errors.table_not_editable':
      'Employees can be added only while the payroll table is locked and payroll is not finalized.',
    'payroll.errors.staff_already_added': 'This employee is already in the payroll table.',
    'payroll.errors.run_not_editable':
      'This payroll has been reviewed or finalized, so employees cannot be added.',
    'payroll.errors.workflow_not_configured':
      'Configure a payslip approval workflow before sending payslips.',
    'payroll.errors.approval_required': 'The payslip approval workflow is not complete.',
    'payroll.errors.payslip_not_payable': 'This payslip is not ready for payment.',
    'payroll.errors.payment_exceeds_balance': 'The payment exceeds the remaining balance.',
    'payroll.errors.advance_payment_invalid_amount':
      'The disbursement must be from {minimum} to {amount}.',
    'payroll.errors.approval_in_progress':
      'This payslip is in approval and cannot be changed directly.',
    'payroll.errors.revision_stale': 'A newer payslip revision exists. Please reload.',
    'payroll.errors.send_not_allowed': 'This payslip cannot be sent in its current state.',
    'payroll.errors.review_required': 'Review payroll internally before sending the payslip.',
    'payroll.errors.resolution_required': 'Explain how the feedback was resolved before resending.',
    'payroll.errors.action_not_allowed':
      'This action is not available in the current payslip state.',
    'payroll.errors.invalid_transition':
      'Cannot {action} this {item} because its current status is {status}. Reload the page to see the latest status.',
    'payroll.errors.unsupported_transition': '{action} does not apply to this {item}.',
    'payroll.inputItem.leave': 'leave request',
    'payroll.inputItem.overtime': 'overtime request',
    'payroll.inputItem.advances': 'salary advance',
    'payroll.inputItem.allowances': 'allowance',
    'payroll.inputItem.insurance': 'insurance profile',
    'payroll.inputItem.payslips': 'payslip',
    'payroll.inputAction.approve': 'approve',
    'payroll.inputAction.reject': 'reject',
    'payroll.inputAction.cancel': 'cancel',
    'payroll.inputAction.mark-paid': 'mark as paid',
    'payroll.inputAction.reverse-payment': 'reverse the payment of',
    'payroll.inputAction.deactivate': 'deactivate',
    'payroll.inputAction.reactivate': 'reactivate',
    'payroll.inputAction.reconcile': 'reconcile',
    'payroll.inputAction.edit': 'edit',
    'payroll.inputAction.delete': 'delete',
    'payroll.inputStatus.pending': 'pending',
    'payroll.inputStatus.approved': 'approved',
    'payroll.inputStatus.rejected': 'rejected',
    'payroll.inputStatus.cancelled': 'cancelled',
    'payroll.inputStatus.paid': 'paid',
    'payroll.inputStatus.partially_paid': 'partially paid',
    'payroll.inputStatus.active': 'active',
    'payroll.inputStatus.inactive': 'inactive',
    'payroll.inputStatus.needs_review': 'needs review',
    'payroll.inputStatus.draft': 'draft',
    'payroll.inputStatus.unknown': 'unknown',
    'payroll.errors.reason_required': 'Please enter a reason.',
    'payroll.errors.not_ready_to_finalize': 'This payslip is not ready to finalize.',
    'payroll.errors.input_changed_recalculate':
      'Payroll inputs changed. Recalculate and review the new amounts before continuing.',
    'payroll.errors.attendance_not_locked_or_changed':
      'Attendance is not locked or changed after locking. Review it and lock attendance again before calculating payroll.',
    'payroll.errors.leave_attendance_conflict':
      'Recorded work time overlaps a leave day. Review the leave request and attendance.',
    'payroll.errors.multiple_insurance_profiles':
      'Multiple insurance profiles apply in this payroll period. Review the employee’s insurance settings.',
    'payroll.errors.social_insurance_profile_conflict':
      'Another employee insurance deduction applies in this period. Remove the duplicate before calculating social insurance from the staff profile base.',
    'payroll.errors.negative_net_salary':
      'Deductions exceed salary. Review advances, tax, insurance, and other deductions.',
    'payroll.errors.job_failed_retry':
      'Payslip creation did not finish. Retry the missing payslips.',
    'payroll.open_staff_salary': 'Update salary',
    'payroll.retry_missing_payslips': 'Calculate missing payslips',
    'payroll.manage_tables': 'Manage payroll tables',
    'payroll.view_payslips': 'Payslips',
    'payroll.sheet_base_salary': 'Base salary',
    'payroll.sheet_addition': 'Bonus',
    'payroll.sheet_deduction': 'Other deductions',
    'payroll.sheet_advance': 'Salary advance',
    'payroll.sheet_adjustment_total': 'Current total',
    'payroll.sheet_reason': 'Reason',
    'payroll.sheet_add_bonus': 'Add bonus',
    'payroll.sheet_edit_bonus': 'Edit bonus',
    'payroll.sheet_add_deduction': 'Add deduction',
    'payroll.sheet_edit_deduction': 'Edit deduction',
    'payroll.sheet_delete_adjustment_confirm': 'Are you sure you want to delete “{name}”? This action cannot be undone.',
    'payroll.sheet_search_employee': 'Search employee name or code',
    'payroll.sheet_all_staff_totals': 'Totals for the whole payroll table',
    'payroll.sheet_total_row': 'Total',
    'payroll.sheet_total_salary': 'Total salary',
    'payroll.sheet_sent_amount': 'Amount sent',
    'payroll.sheet_remaining_to_send': 'Amount remaining to send',
    'payroll.sheet_line_direction': 'Category',
    'payroll.sheet_direction_earning': 'Added to salary',
    'payroll.sheet_direction_deduction': 'Deduction',
    'payroll.sheet_direction_informational': 'Information',
    'payroll.sheet_actual_work_days': 'Actual workdays',
    'payroll.sheet_actual_work_time': 'Total time worked',
    'payroll.sheet_hours_minutes_value': '{hours} hours {minutes} minutes',
    'payroll.sheet_hourly_rate': 'Pay per hour',
    'payroll.sheet_hourly_earned': 'Pay for hours worked',
    'payroll.sheet_payable_hours': 'Paid hours',
    'payroll.sheet_payable_minutes': 'Minutes',
    'payroll.sheet_work_time_hint':
      'This employee is paid hourly. Workdays count days worked; pay uses total hours and minutes. Changes apply only to this payslip and leave attendance unchanged.',
    'payroll.sheet_reset_work_time': 'Use actual hours',
    'payroll.sheet_daily_rate': 'Pay per workday',
    'payroll.sheet_base_earned': 'Pay for worked days',
    'payroll.sheet_payable_work_days': 'Paid workdays',
    'payroll.sheet_work_days_hint':
      'Paid workdays apply only to this payslip; attendance records stay unchanged.',
    'payroll.sheet_current_total': 'Current base pay total',
    'payroll.sheet_preview_total': 'Base pay total after adjustment',
    'payroll.sheet_reset_work_days': 'Use actual workdays',
    'payroll.sheet_overtime_hours': 'Overtime hours',
    'payroll.sheet_overtime_multiplier': 'Multiplier',
    'payroll.sheet_overtime_rate': 'Overtime hourly rate',
    'payroll.sheet_overtime_total': 'Total overtime pay',
    'payroll.sheet_allowance_total': 'Total allowances',
    'payroll.sheet_paid_amount': 'Amount paid',
    'payroll.sheet_remaining_amount': 'Amount remaining',
    'payroll.table_remaining_payable': 'Remaining to pay',
    'payroll.payslip_received_amount': 'Received',
    'payroll.payslip_remaining_amount': 'Remaining',
    'payroll.payslip_unpaid_balance': 'Unpaid balance',
    'payroll.sheet_allowance_name': 'Allowance name',
    'payroll.sheet_allowance_unit_price': 'Unit price',
    'payroll.sheet_allowance_quantity': 'Quantity',
    'payroll.sheet_allowance_unit_day': 'days',
    'payroll.sheet_allowance_unit_shift': 'shifts',
    'payroll.sheet_allowance_unit_hour': 'hours',
    'payroll.sheet_allowance_unit_month': 'months',
    'payroll.sheet_allowance_unit_item': 'items',
    'payroll.sheet_add_allowance': 'Add allowance',
    'payroll.sheet_edit_allowance': 'Edit allowance',
    'payroll.search_table': 'Search payroll table name or month',
    'payroll.table_period_dates': 'Payroll period dates',
    'payroll.table_staff_count': 'Total employees in payroll table',
    'payroll.create_table': 'Add payroll table',
    'payroll.save_draft': 'Save draft',
    'payroll.edit_draft_table': 'Continue draft payroll table',
    'payroll.table_name': 'Payroll table name',
    'payroll.table_name_default': 'Payroll {month}',
    'payroll.custom_range': 'Custom range',
    'payroll.date_from': 'From date',
    'payroll.date_to': 'To date',
    'payroll.notes': 'Notes',
    'payroll.select_employees': 'Select employees',
    'payroll.select_all_employees': 'Select all employees',
    'payroll.select_all_employees_hint':
      'The payroll table will include all employees in your managed scope.',
    'payroll.table_name_required': 'Enter a payroll table name.',
    'payroll.period_end_month': 'Payroll period end month (YYYY-MM)',
    'payroll.period_start_day': 'Payroll period start day',
    'payroll.period_date_range': 'Payroll period date range',
    'payroll.period_cycle_hint':
      'Choose day 1 for a calendar month; any other day runs from that day in the previous month through the day before it in the selected month.',
    'payroll.create_period': 'Create period',
    'payroll.edit_period': 'Edit payroll period',
    'payroll.delete_period': 'Delete payroll period',
    'payroll.delete_table': 'Delete payroll table',
    'payroll.delete_table_confirm':
      'Are you sure you want to delete this payroll table? This cannot be undone.',
    'payroll.confirm_delete_period':
      'Are you sure you want to delete this payroll period? This cannot be undone.',
    'payroll.errors.period_not_editable':
      'Only open payroll periods can be edited or deleted. Reopen attendance first.',
    'payroll.errors.period_locked':
      'This employee’s payroll period is locked. Reopen the period before changing attendance.',
    'payroll.errors.finalized_period_immutable':
      'Attendance cannot be reopened because at least one payslip in this period has been finalized or paid. Attendance for this period can no longer be changed.',
    'payroll.errors.period_has_payments':
      'This payroll table has paid payslips and cannot be cancelled or deleted.',
    'payroll.errors.period_already_cancelled': 'This payroll table has already been cancelled.',
    'payroll.errors.period_cancelled': 'This payroll table has been cancelled.',
    'payroll.cancel_table_reason_max_length': 'Cancellation reason cannot exceed 500 characters.',
    'payroll.errors.period_has_payroll_data':
      'This period already has payroll runs or payslip jobs and cannot be edited or deleted.',
    'payroll.errors.table_not_draft': 'This payroll table is no longer an editable draft.',
    'payroll.errors.draft_must_be_completed': 'Complete the draft using Add payroll table.',
    'payroll.errors.staff_selection_required':
      'Select at least one employee before creating the payroll table.',
    'payroll.period': 'Period',
    'payroll.open': 'Open',
    'payroll.locked': 'Attendance locked',
    'payroll.lock': 'Lock attendance',
    'payroll.reopen': 'Reopen attendance',
    'payroll.create_many': 'Create payslips',
    'payroll.all_filtered': 'Select all matching employees',
    'payroll.preview': 'Preview',
    'payroll.create_eligible': 'Create eligible payslips',
    'payroll.eligible': 'Eligible',
    'payroll.blocked': 'Blocked',
    'payroll.already_exists': 'Already exists',
    'payroll.created': 'Created',
    'payroll.result': 'Result',
    'payroll.gross': 'Gross salary',
    'payroll.deductions': 'Deductions',
    'payroll.net': 'Net',
    'payroll.calculated': 'Calculated',
    'payroll.reviewed': 'Reviewed',
    'payroll.finalized': 'Finalized',
    'payroll.draft': 'Draft',
    'payroll.calculate': 'Recalculate',
    'payroll.review': 'Review payroll',
    'payroll.finalize': 'Finalize payroll',
    'payroll.detail': 'Details',
    'payroll.payslip': 'Payslip',
    'payroll.payslip_detail_title': 'Payroll details',
    'payroll.payslip_document_title': 'Payslip',
    'payroll.payslip_document_sheet': 'Payslip',
    'payroll.payslip_attendance_section': 'Attendance and work time',
    'payroll.payslip_items_section': 'Payroll items',
    'payroll.payslip_deductions_section': 'Deductions',
    'payroll.payslip_earnings_total': 'Total earnings',
    'payroll.payslip_deductions_total': 'Total deductions',
    'payroll.payslip_net_description': 'Earnings after deductions',
    'payroll.payslip_payment_section': 'Payment summary',
    'payroll.payslip_worked_time': 'Time worked',
    'payroll.payslip_late_time': 'Late',
    'payroll.payslip_early_time': 'Left early',
    'payroll.payslip_overtime_time': 'Overtime duration',
    'payroll.payslip_overtime_pay': 'Overtime pay',
    'payroll.payslip_partially_paid_leave': 'Partially paid leave half-days',
    'payroll.payslip_paid_leave_equivalent': 'Equivalent paid leave half-days',
    'payroll.payslip_hours_minutes': '{hours} hours {minutes} minutes',
    'payroll.payslip_minutes': '{minutes} minutes',
    'payroll.payslip_other_item': 'Other item',
    'payroll.pay': 'Record payment',
    'payroll.pay_salary': 'Pay salary',
    'payroll.my_payslips': 'My payslips',
    'payroll.managed_payslips': 'Managed payslips',
    'payroll.approval_workflow': 'Payslip approval workflow',
    'payroll.approval_status': 'Payslip approval status',
    'payroll.workflow_manager_final': 'Employee confirms, manager approves last',
    'payroll.workflow_employee_final': 'Employee confirms, then payment',
    'payroll.approval_revision': 'Sent revision',
    'payroll.approval_history': 'Approval history',
    'payroll.send_payslip': 'Send payslip',
    'payroll.send_all_payslips': 'Send payslips',
    'payroll.sheet_pay_selected': 'Pay selected ({count})',
    'payroll.sheet_pay_selected_title': 'Pay selected payslips',
    'payroll.sheet_payment_summary': '{count} payslips · Total to pay: {amount}',
    'payroll.sheet_payment_result': 'Paid: {paid} · Not paid: {failed}',
    'payroll.sheet_payment_failed': 'Could not record the payment.',
    'payroll.sheet_payment_no_methods':
      'No payment method is available. Configure one in system settings.',
    'payroll.sheet_retry_payment': 'Retry unpaid payslips',
    'payroll.sheet_review_confirm':
      'Confirm that you have reviewed every payslip in this payroll table? You can send them to employees afterward.',
    'payroll.sheet_recalculate': 'Recalculate payroll',
    'payroll.sheet_recalculate_confirm':
      'Recalculate all payslips using the latest data? Amounts may change. Review them before approval and sending.',
    'payroll.sheet_recalculate_after_error':
      'Payroll inputs changed. Recalculate, review the new amounts, then approve.',
    'payroll.sheet_recalculated_review_hint':
      'Payroll was recalculated. Review the new amounts before approving and sending payslips.',
    'payroll.send_all_payslips_confirm':
      'Send payslips to all {count} employees in this payroll table? Previously sent payslips will be skipped.',
    'payroll.send_all_payslips_result':
      'Sent: {sent} · Previously sent: {skipped} · Could not send: {blocked}',
    'payroll.approve_payslip': 'Confirm details',
    'payroll.request_payslip_changes': 'Request changes',
    'payroll.manager_final_approve': 'Manager final approval',
    'payroll.return_payslip_for_changes': 'Return for changes',
    'payroll.cancel_payslip_approval': 'Cancel payslip approval',
    'payroll.approval.not_sent': 'Not sent',
    'payroll.approval.awaiting_employee': 'Awaiting employee',
    'payroll.approval.changes_requested': 'Changes requested',
    'payroll.approval.awaiting_manager_final': 'Awaiting manager approval',
    'payroll.approval.payable': 'Ready for payment',
    'payroll.approval.cancelled': 'Cancelled',
    'payroll.approval_event.sent': 'Payslip sent',
    'payroll.approval_event.employee_approved': 'Employee confirmed',
    'payroll.approval_event.changes_requested': 'Employee requested changes',
    'payroll.approval_event.manager_final_approved': 'Manager approved',
    'payroll.approval_event.returned_for_changes': 'Manager returned for changes',
    'payroll.approval_event.cancelled': 'Payslip approval cancelled',
    'payroll.approval_action.send': 'Send payslip',
    'payroll.approval_action.approve': 'Confirm payslip',
    'payroll.approval_action.request-changes': 'Request changes',
    'payroll.approval_action.manager-final-approve': 'Final approval',
    'payroll.approval_action.return-for-changes': 'Return for changes',
    'payroll.approval_action.cancel-approval': 'Cancel payslip approval',
    'payroll.approval_confirm.send': 'Send this payslip revision to the employee?',
    'payroll.approval_confirm.approve': 'Confirm the information in this payslip revision?',
    'payroll.approval_confirm.manager-final-approve': 'Approve this payslip for payment?',
    'payroll.reverse_payment': 'Reverse payment',
    'payroll.base_salary': 'Earned salary',
    'payroll.work_day_breakdown_title': 'Reduced workday details',
    'payroll.leave_for_shift': 'Leave request for shift: {shift}',
    'payroll.work_day_breakdown_legacy_notice': 'This payslip was created before reduced-workday details were stored. Recalculate payroll to see the affected dates and reasons.',
    'payroll.work_day_worked_time': 'Worked time / shift',
    'payroll.work_day_credited': 'Credited days',
    'payroll.work_day_deducted': 'Reduced days',
    'payroll.work_day_reason.missing_check_in': 'Missing check-in',
    'payroll.work_day_reason.missing_check_out': 'Missing check-out',
    'payroll.work_day_reason.late': 'Late arrival',
    'payroll.work_day_reason.early_leave': 'Early departure',
    'payroll.work_day_reason.insufficient_work_time': 'Insufficient worked time',
    'payroll.paid_leave': 'Paid leave',
    'payroll.allowance': 'Allowance',
    'payroll.advance': 'Paid advance',
    'payroll.employer_insurance': 'Employer insurance',
    'payroll.confirm_attendance': 'Confirm attendance',
    'payroll.confirm_selected': 'Confirm selected days',
    'payroll.confirm_all': 'Confirm all eligible days',
    'payroll.date': 'Date',
    'payroll.unconfirmed': 'Unconfirmed',
    'payroll.confirmed': 'Confirmed',
    'payroll.changed_after_confirmation': 'Attendance changed; confirm again',
    'payroll.not_required': 'Not required',
    'payroll.minutes_per_day': 'Standard minutes per day',
    'payroll.rounding_minutes': 'Minute rounding increment',
    'payroll.rounding_mode': 'Rounding mode',
    'payroll.nearest': 'Nearest',
    'payroll.down': 'Round down',
    'payroll.up': 'Round up',
    'payroll.half_day_threshold_percent': 'Half-day threshold (%)',
    'payroll.full_day_threshold_percent': 'Full-day threshold (%)',
    'payroll.confirmation_deadline_day': 'Confirmation deadline day (blank = month end)',
    'payroll.selection_changed': 'Preview again after changing employees.',
    'payroll.confirm_hint':
      'Review your attendance before confirming. Request corrections from the day details if needed.',
    'payroll.confirm_prompt': 'Confirm that the selected days are correct?',
    'payroll.confirm_for_staff_prompt':
      'You are confirming attendance for {name}. Are the selected days correct?',
    'payroll.error_required': 'Complete all required fields.',
    'payroll.errors.advance_end_before_start':
      'End date ({end}) is before start date ({start}). Select a later end date.',
    'payroll.errors.insufficient_leave_quota':
      'This request cannot be approved because the employee does not have enough quota. Enable conversion to unpaid leave or grant more quota.',
    'payroll.errors.attendance_not_ended': 'The work shift has not ended.',
    'payroll.errors.attendance_missing_check_in': 'The shift has no check-in time.',
    'payroll.errors.attendance_missing_check_out':
      'The employee checked in but has no check-out time.',
    'payroll.errors.attendance_unmatched': 'Attendance data does not match a work shift.',
    'payroll.errors.attendance_ambiguous': 'Attendance data cannot be matched to a specific shift.',
    'payroll.errors.adjustment_pending': 'An attendance correction request is pending.',
    'payroll.errors.leave_pending': 'A leave request is pending approval.',
    'payroll.errors.faceid_pending': 'Face recognition attendance data is pending review.',
    'payroll.errors.overtime_pending': 'An overtime request is pending approval.',
    'payroll.errors.overtime_needs_review': 'An overtime request needs review.',
    'payroll.errors.overtime_delete_pending_only': 'Only pending overtime requests can be deleted.',
    'payroll.errors.attendance_unconfirmed': 'The employee has not confirmed attendance.',
    'payroll.errors.attendance_changed_after_confirmation':
      'Attendance records changed after confirmation; please confirm again.',
    'payroll.errors.adjustment_rejected':
      'Attendance adjustment was rejected; review required.',
    'payroll.errors.leave_quota_exhausted':
      'This leave type has no remaining quota. Select another leave type.',
    'payroll.errors.insufficient_leave_quota_to_request':
      'The remaining leave balance is insufficient for this request.',
    'payroll.errors.leave_requires_schedule':
      'The employee does not have a scheduled shift in this leave period.',
    'payroll.errors.system_leave_type_immutable':
      'The system default unpaid leave type cannot be edited.',
    'payroll.errors.leave_type_in_use':
      'This leave type cannot be deleted because it is used by leave requests or quota records.',
    'payroll.errors.allowance_type_in_use':
      'This allowance type cannot be deleted because allowance records already use it.',
    'payroll.errors.reversal_details_required':
      'Enter a reason before reversing the latest disbursement.',
    'payroll.errors.reconciliation_reason_required':
      'Please enter the reconciliation reason.',
    'payroll.errors.leave_quota_balance_negative':
      'Cannot update because the employee leave balance would become negative.',
    'payroll.errors.staff_must_be_active_to_update_leave_quota':
      'Leave quota can only be updated for active employees.',
    'payroll.errors.overtime_end_after_start':
      'Overtime must end after it starts. For overnight overtime, select the following day as the end date.',
    'payroll.errors.overtime_exceeds_24_hours': 'An overtime request cannot exceed 24 hours.',
    'payroll.errors.invalid_overtime_range':
      'The overtime period is invalid. It must end after it starts and cannot exceed 24 hours.',
    'payroll.errors.invalid_table_range':
      'The date range is invalid. The end date must be on or after the start date.',
    'payroll.errors.table_range_conflict':
      'A payroll table already exists for this end month with a different date range.',
    'payroll.errors.table_already_exists':
      'A payroll table already exists for this date range with different details or employees.',
    'payroll.errors.overtime_overlaps_shift':
      "The overtime period overlaps the employee's scheduled shift. Select a time outside the shift.",
    'payroll.errors.overtime_shift_required': 'Select a work shift before entering overtime.',
    'payroll.errors.overtime_not_after_selected_shift':
      'Overtime must start when or after the selected shift ends and within 24 hours.',
    'payroll.errors.payroll_input_overlap': 'This period overlaps an existing request.',
    'payroll.errors.staff_allowance_assignment_overlap':
      'This staff member already has this allowance assigned for this time period.',
    'payroll.leave_create_success': 'Leave request created successfully.',
    'payroll.leave_create_failure': 'Could not create the leave request.',
    'payroll.overtime_create_success': 'Overtime request created successfully.',
    'payroll.allowance_create_failure': 'Failed to add allowance.',
    'payroll.allowance_create_success': 'Allowance added successfully.',
    'payroll.overtime_create_failure': 'Failed to add overtime request.',
    'payroll.advance_create_success': 'Salary advance request created successfully.',
    'payroll.advance_create_failure': 'Could not create the salary advance request.',
    'payroll.period_hint':
      'Lock attendance after employees confirm it. Changed days and pending requests block locking.',
    'payroll.print': 'Print / save PDF',
    'payroll.retry_blocked': 'Recheck blocked rows',
    'payroll.adjust': 'Adjust payslip',
    'payroll.adjustment_type': 'Adjustment type',
    'payroll.addition': 'Addition',
    'payroll.deduction': 'Other deduction',
    'payroll.tax': 'Manual tax',
    'payroll.export': 'Export Excel',
    'payroll.standard_days': 'Scheduled days',
    'payroll.actual_work_days': 'Actual workdays',
    'payroll.payable_work_days': 'Payable workdays',
    'payroll.manual_work_days': 'Adjusted workdays',
    'payroll.manual_work_minutes': 'Adjusted work time',
    'payroll.work_day_rate': 'Daily rate',
    'payroll.worked_half_days': 'Worked half days',
    'payroll.worked_minutes': 'Worked minutes',
    'payroll.late_minutes': 'Late time',
    'payroll.early_leave_minutes': 'Early leave time',
    'payroll.paid_leave_half_days': 'Paid leave half days',
    'payroll.partially_paid_leave_half_days': 'Partially paid leave half days',
    'payroll.paid_leave_equivalent_half_days': 'Paid leave equivalent half days',
    'payroll.unpaid_leave_half_days': 'Unpaid leave half days',
    'payroll.absent_half_days': 'Missing half days',
    'payroll.overtime_minutes': 'Overtime minutes',
    'payroll.notification.attendance.changed_after_confirmation':
      'Attendance changed after confirmation. Review and confirm it again.',
    'payroll.notification.leave.approved': 'Your leave request was approved.',
    'payroll.notification.leave.rejected': 'Your leave request was rejected.',
    'payroll.notification.overtime.approved': 'Your overtime request was approved.',
    'payroll.notification.overtime.rejected': 'Your overtime request was rejected.',
    'payroll.notification.advances.approved': 'Your salary advance was approved.',
    'payroll.notification.advances.rejected': 'Your salary advance was rejected.',
    'payroll.notification.payroll.attendance_reopened':
      'Attendance was reopened. Review your attendance data.',
    'payroll.notification.payroll.payslip_finalized':
      'Your payslip was finalized. Sign in to view details.',
    'payroll.notification.payroll.payslip_sent':
      'A new payslip is ready. Sign in to review and confirm it.',
    'payroll.notification.payroll.payslip_feedback':
      'An employee requested changes to a payslip. Sign in to review it.',
    'payroll.notification.payroll.payslip_employee_approved':
      'An employee confirmed a payslip. Sign in to review the next step.',
    'payroll.notification.payroll.payslip_returned':
      'Your payslip is being reviewed again. You will receive a new revision.',
    'payroll.notification.payroll.payslip_cancelled':
      'Your payslip approval was cancelled. Sign in to view details.',
    'payroll.notification.payroll.payment_recorded':
      'Salary payment was recorded. Sign in to view details.',
    'payroll.notification.attendance.confirmation_deadline':
      'The attendance confirmation deadline is near. Review and confirm remaining days.',
  },
}
